import React from "react"
import { blob, blobLeft } from "./shapes.module.css"

export function Blob() {
  return <div className={blob} />
}

export function BlobSmall() {
  return (
    <svg
      className={blobLeft}
      width="123"
      height="376"
      viewBox="0 0 123 376"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-56.5713"
        width="195.097"
        height="325.162"
        rx="97.5485"
        transform="rotate(23.2641 -56.5713 0)"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-3.04147"
          y1="-37.7086"
          x2="245.577"
          y2="421.419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF957D" />
          <stop offset="0.461057" stopColor="#D9629F" />
          <stop offset="1" stopColor="#2B4BC3" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export function BlobLightPink() {
  return (
    <svg
      width="309"
      height="618"
      viewBox="0 0 309 618"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="241.887"
        width="367.452"
        height="612.42"
        rx="183.726"
        transform="rotate(23.2641 241.887 0)"
        fill="url(#pink)"
      />
      <defs>
        <linearGradient
          id="pink"
          x1="342.707"
          y1="-71.0215"
          x2="441.08"
          y2="824.323"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.228339" stopColor="#FFDFED" />
          <stop offset="0.697917" stopColor="#FFC4DE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export function Dashes(props: { className?: string }) {
  const { className } = props
  return (
    <svg
      className={`w-15 h-15 fill-current ${className}`}
      width="87"
      height="75"
      viewBox="0 0 87 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M82.3146 50.0937L76.7705 3.67035"
        stroke="white"
        strokeWidth="5.55179"
        strokeLinecap="round"
      />
      <path
        d="M35.5803 70.4852L4.15332 35.4336"
        stroke="white"
        strokeWidth="5.55179"
        strokeLinecap="round"
      />
      <path
        d="M56.7442 58.0866L49.7068 41.2846"
        stroke="white"
        strokeWidth="5.55179"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function ArrowRightWithGradient() {
  return (
    <svg
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.219 0.274445C11.1525 0.192932 11.0702 0.126477 10.9772 0.0793166C10.8843 0.0321563 10.7827 0.00532548 10.6791 0.000534609C10.5754 -0.00425626 10.4719 0.013098 10.3751 0.0514909C10.2784 0.0898839 10.1905 0.148473 10.1172 0.223524C10.0438 0.298574 9.9865 0.388439 9.94896 0.487389C9.91142 0.586339 9.89445 0.692203 9.89914 0.798232C9.90382 0.904261 9.93006 1.00813 9.97616 1.10321C10.0223 1.1983 10.0872 1.28251 10.1669 1.35049L11.4512 2.76359H0.709375C0.517851 2.77398 0.337521 2.85912 0.205545 3.00145C0.0735682 3.14379 0 3.33249 0 3.52865C0 3.72482 0.0735682 3.91351 0.205545 4.05585C0.337521 4.19819 0.517851 4.28333 0.709375 4.29372H11.4512L10.1585 5.70036C10.0232 5.84529 9.94771 6.03799 9.94771 6.23838C9.94771 6.43878 10.0232 6.63147 10.1585 6.7764C10.2275 6.8472 10.3095 6.90337 10.3998 6.9417C10.49 6.98003 10.5868 6.99976 10.6846 6.99976C10.7823 6.99976 10.8791 6.98003 10.9693 6.9417C11.0596 6.90337 11.1416 6.8472 11.2106 6.7764L13.7762 4.05914C13.847 3.98947 13.9033 3.90591 13.9417 3.81346C13.9802 3.72102 14 3.62158 14 3.52112C14 3.42066 13.9802 3.32122 13.9417 3.22878C13.9033 3.13633 13.847 3.05277 13.7762 2.9831L11.219 0.274445Z"
        fill="url(#paint0_linear_1144:5858)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1144:5858"
          x1="-2.52491"
          y1="0.499756"
          x2="3.33004"
          y2="16.9374"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF8F83" />
          <stop offset="1" stopColor="#2B4BC3" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export function ArrowRight() {
  return (
    <svg
      width="11"
      height="6"
      viewBox="0 0 11 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.61708 0.207612C8.56684 0.146004 8.50461 0.0957765 8.43435 0.0601325C8.36409 0.0244884 8.28734 0.00420955 8.20898 0.000588583C8.13063 -0.00303239 8.0524 0.010084 7.97928 0.0391017C7.90617 0.0681193 7.83976 0.112402 7.7843 0.169125C7.72884 0.225849 7.68555 0.293769 7.65718 0.368556C7.62881 0.443343 7.61598 0.523356 7.61952 0.603493C7.62306 0.68363 7.64289 0.762134 7.67774 0.834C7.71259 0.905865 7.76169 0.969515 7.82193 1.02089L8.79256 2.08892H0.673845C0.52909 2.09677 0.392796 2.16112 0.293047 2.2687C0.193299 2.37628 0.137695 2.5189 0.137695 2.66716C0.137695 2.81542 0.193299 2.95804 0.293047 3.06562C0.392796 3.1732 0.52909 3.23755 0.673845 3.2454H8.79256L7.81557 4.30855C7.7133 4.41809 7.65624 4.56373 7.65624 4.71519C7.65624 4.86665 7.7133 5.01229 7.81557 5.12183C7.86772 5.17534 7.92968 5.21779 7.99791 5.24676C8.06613 5.27573 8.13927 5.29064 8.21314 5.29064C8.28701 5.29064 8.36015 5.27573 8.42838 5.24676C8.4966 5.21779 8.55857 5.17534 8.61072 5.12183L10.5498 3.06811C10.6033 3.01545 10.6459 2.95229 10.6749 2.88242C10.704 2.81255 10.719 2.7374 10.719 2.66147C10.719 2.58554 10.704 2.51038 10.6749 2.44051C10.6459 2.37064 10.6033 2.30749 10.5498 2.25483L8.61708 0.207612Z"
        fill="white"
      />
    </svg>
  )
}

export function ArrowDownWhite() {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 14.975c-.1333 0-.2626-.025-.388-.075-.1253-.05-.2293-.1166-.312-.2l-4.59995-4.6c-.18333-.18328-.275-.41662-.275-.69995 0-.28334.09167-.51667.275-.7.18333-.18333.41667-.275.7-.275.28333 0 .51667.09167.7.275L12 12.6l3.9-3.89995c.1834-.18333.4167-.275.7-.275.2834 0 .5167.09167.7.275.1834.18333.275.41666.275.7 0 .28333-.0916.51667-.275.69995l-4.6 4.6c-.1.1-.2083.171-.325.213-.1166.042-.2416.0627-.375.062Z"
        fill="#fff"
      />
    </svg>
  )
}

export function CircularLines() {
  return (
    <svg
      width="256"
      height="361"
      viewBox="0 0 256 361"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          opacity="0.95"
          d="M262.834 -49.2648C266.242 -51.9252 270.031 -53.6345 273.966 -54.2857C277.901 -54.9368 281.895 -54.5158 285.7 -53.0491C293.269 -50.0731 299.693 -43.4365 303.67 -34.4832C305.698 -30.015 307.002 -25.046 307.498 -19.8871C307.995 -14.7281 307.674 -9.49038 306.556 -4.50142C304.288 5.42432 299.226 13.8478 292.397 19.0614C288.913 21.7855 285.03 23.515 281.002 24.1372C276.974 24.7593 272.89 24.26 269.019 22.6718C261.657 19.5971 255.429 13.0433 251.546 4.28379C249.518 -0.184761 248.216 -5.15394 247.72 -10.3128C247.223 -15.4717 247.545 -20.7094 248.663 -25.6981C250.931 -35.6296 255.998 -44.0561 262.834 -49.2648V-49.2648Z"
          stroke="url(#paint0_linear_1178:10461)"
          strokeWidth="1.77431"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.9"
          d="M255.772 -63.1379C265.713 -71.4926 277.869 -73.7521 288.41 -69.6044C298.951 -65.4567 307.836 -56.7426 314.21 -43.7821C320.585 -30.8216 322.305 -14.8115 319.142 -0.985866C315.979 12.8398 309.33 24.4848 299.448 32.8395C289.206 41.5062 276.574 43.5761 265.804 38.9504C255.693 34.6487 247.156 26.0333 241.013 13.4836C234.635 0.471728 232.918 -15.487 236.078 -29.3086C239.239 -43.1303 245.887 -54.7794 255.772 -63.1379Z"
          stroke="url(#paint1_linear_1178:10461)"
          strokeWidth="1.13556"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.86"
          d="M249.331 -76.7501C262.207 -88.2846 278.342 -91.5396 291.745 -86.1278C305.142 -80.7833 316.424 -69.9005 325.215 -53.136C334.012 -36.2529 336.494 -15.0958 332.367 2.47855C328.291 20.045 319.991 34.8384 307.206 46.3611C293.833 58.3854 277.008 61.3322 263.303 55.1937C250.554 49.5805 239.751 38.911 231.321 22.7509C222.525 5.8678 220.042 -15.2894 224.17 -32.8637C228.246 -50.4301 236.542 -65.2235 249.331 -76.7501Z"
          stroke="url(#paint2_linear_1178:10461)"
          strokeWidth="1.25976"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.81"
          d="M242.848 -90.086C258.634 -105.002 278.885 -109.383 295.047 -102.604C311.204 -95.9322 324.673 -83.0388 336.019 -62.5295C347.391 -41.8306 350.732 -15.2775 345.563 5.91519C340.474 27.1 330.638 44.7573 315 59.6376C298.548 75.2447 277.36 79.1712 260.848 71.4091C245.574 64.4054 232.671 51.8004 221.823 32.0812C210.45 11.3822 207.109 -15.1709 212.279 -36.3596C217.373 -57.5563 227.206 -75.2214 242.848 -90.086Z"
          stroke="url(#paint3_linear_1178:10461)"
          strokeWidth="1.4017"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.76"
          d="M236.323 -103.201C255.001 -121.691 279.494 -127.324 298.31 -119.08C317.133 -110.986 332.579 -96.1929 346.639 -72.0139C360.741 -47.5228 365.04 -15.4039 358.752 9.26892C352.576 33.9457 341.279 54.1982 322.854 72.6297C313.196 81.9285 301.766 88.5687 290.529 90.9981C279.789 93.3853 268.764 92.2037 258.463 87.5614C240.767 79.0803 225.927 64.6504 212.539 41.451C198.437 16.9599 194.138 -15.159 200.425 -39.8318C206.598 -64.5085 217.88 -84.765 236.323 -103.201Z"
          stroke="url(#paint4_linear_1178:10461)"
          strokeWidth="1.52591"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.71"
          d="M229.746 -116.039C240.42 -126.684 253.127 -134.652 265.702 -137.883C277.607 -141.063 289.933 -140.248 301.534 -135.513C322.923 -125.898 340.137 -109.319 357.053 -81.5377C365.169 -67.5422 371.245 -50.8804 373.713 -34.3924C376.14 -18.7831 375.518 -2.62268 371.905 12.5871C364.573 40.6334 351.929 63.2046 330.744 85.3809C319.597 96.5244 306.227 104.681 293.123 107.656C280.737 110.581 267.984 109.22 256.122 103.706C236.115 93.6723 219.534 77.5517 203.437 50.9078C195.321 36.9083 189.245 20.2465 186.778 3.75844C184.351 -11.8508 184.973 -28.0112 188.585 -43.221C195.915 -71.2791 208.559 -93.8623 229.746 -116.039Z"
          stroke="url(#paint5_linear_1178:10461)"
          strokeWidth="1.65011"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.67"
          d="M223.13 -128.62C235.18 -141.094 249.758 -150.642 264.125 -154.517C277.597 -158.323 291.596 -157.424 304.72 -151.91C316.981 -146.716 327.194 -138.795 337.413 -128.999C347.529 -119.056 357.651 -107.214 367.271 -91.1405C376.781 -75.3398 384.066 -56.225 387.021 -37.3866C389.922 -19.7213 389.237 -1.36693 385.033 15.8421C381.071 31.9193 375.028 45.3065 367.545 58.7094C359.959 71.9662 350.93 85.2427 338.672 97.8517C326.091 110.923 310.706 120.715 295.724 124.278C281.703 127.764 267.224 126.198 253.828 119.747C242.41 114.241 232.74 106.467 222.997 96.8839C213.357 87.198 203.68 75.6991 194.531 60.3605C185.02 44.5598 177.736 25.441 174.78 6.60656C171.878 -11.0586 172.563 -29.4134 176.769 -46.6221C180.73 -62.6993 186.77 -76.0904 194.242 -89.4894C201.839 -102.726 210.871 -116.007 223.13 -128.62Z"
          stroke="url(#paint6_linear_1178:10461)"
          strokeWidth="1.77431"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.62"
          d="M216.47 -140.944C229.882 -155.319 246.358 -166.565 262.533 -171.124C277.562 -175.594 293.235 -174.611 307.87 -168.28C321.405 -162.354 332.428 -153.455 343.693 -142.627C354.821 -131.626 366.191 -118.693 377.295 -100.755C388.258 -83.1692 396.835 -61.5657 400.311 -40.3572C403.719 -20.6513 402.97 -0.100377 398.142 19.0889C393.623 36.8371 386.836 51.2908 378.56 66.0605C370.17 80.6524 360.307 95.5565 346.627 110.113C332.621 125.199 315.193 136.741 298.32 140.924C282.68 145.02 266.478 143.251 251.57 135.821C239.023 129.552 228.575 120.857 217.829 110.299C207.225 99.6014 196.337 87.0359 185.787 69.9435C174.821 52.3573 166.247 30.7538 162.771 9.54531C159.361 -10.1605 160.111 -30.7119 164.94 -49.9009C169.459 -67.649 176.243 -82.1027 184.504 -96.8724C192.942 -111.476 202.796 -126.384 216.47 -140.944Z"
          stroke="url(#paint7_linear_1178:10461)"
          strokeWidth="1.89851"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.57"
          d="M209.766 -153.008C224.528 -169.37 242.923 -182.421 260.923 -187.703C278.975 -193.308 296.623 -191.147 310.981 -184.614C325.742 -177.93 337.492 -168.023 349.759 -156.22C361.858 -144.188 374.462 -130.224 387.115 -110.461C399.593 -91.1052 409.547 -66.9854 413.575 -43.3791C417.85 -19.7097 416.202 3.42651 411.219 22.257C406.119 41.6129 398.566 57.0185 389.564 73.0997C380.385 88.9597 369.738 105.491 354.666 122.082C339.257 139.257 319.753 152.672 300.967 157.507C283.724 162.243 265.801 160.263 249.406 151.811C235.774 144.752 224.642 135.133 212.954 123.618C201.415 111.942 189.323 98.369 177.317 79.5425C164.839 60.1866 154.886 36.0628 150.858 12.4606C146.58 -11.2089 148.231 -34.349 153.211 -53.1756C158.311 -72.5314 165.864 -87.9371 174.868 -104.022C184.045 -119.886 194.691 -136.422 209.766 -153.008Z"
          stroke="url(#paint8_linear_1178:10461)"
          strokeWidth="2.02271"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.52"
          d="M203.017 -164.815C219.084 -183.235 239.455 -198.206 259.302 -204.246C279.209 -210.693 298.595 -208.196 314.056 -200.916C330.023 -193.434 342.398 -182.54 355.63 -169.757C368.647 -156.722 382.502 -141.794 396.764 -120.214C410.809 -99.1438 422.226 -72.4366 426.839 -46.4129C431.752 -20.3101 429.851 5.10928 424.296 25.3816C418.593 46.3175 410.281 62.5448 400.533 79.894C390.591 96.9627 379.206 115.126 362.749 133.822C345.959 153.178 324.341 168.583 303.626 174.114C284.792 179.529 265.149 177.325 247.29 167.793C232.619 159.893 220.882 149.362 208.268 136.931C195.841 124.29 182.538 109.773 169.014 89.2282C154.966 68.158 143.548 41.4311 138.939 15.4232C134.026 -10.6796 135.927 -36.095 141.479 -56.3713C147.185 -77.3072 155.496 -93.5306 165.242 -110.864C175.166 -127.952 186.559 -146.119 203.017 -164.815Z"
          stroke="url(#paint9_linear_1178:10461)"
          strokeWidth="2.14691"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.48"
          d="M196.225 -176.366C213.59 -196.907 235.952 -213.924 257.664 -220.773C279.448 -228.101 300.579 -225.277 317.094 -217.195C334.205 -208.899 347.132 -196.97 361.262 -183.255C375.153 -169.228 390.246 -153.407 406.182 -130.03C421.848 -107.261 434.823 -77.9391 440.047 -49.4702C445.636 -20.9064 443.482 6.80008 437.318 28.4549C430.991 50.8919 421.893 67.8421 411.433 86.3645C400.736 104.579 388.67 124.369 370.845 145.258C352.694 166.873 328.924 184.364 306.266 190.637C283.491 197.455 261.828 193.007 245.201 183.697C229.535 174.967 217.28 163.48 203.781 150.156C190.504 136.583 175.986 121.177 160.887 98.93C145.222 76.1652 132.243 46.8391 127.02 18.3702C121.431 -10.1935 123.585 -37.9001 129.749 -59.555C136.076 -81.988 145.174 -98.9422 155.633 -117.469C166.331 -135.683 178.397 -155.473 196.225 -176.366Z"
          stroke="url(#paint10_linear_1178:10461)"
          strokeWidth="2.28886"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.43"
          d="M189.389 -187.655C208.028 -210.432 232.406 -229.571 256.013 -237.27C279.689 -245.526 302.576 -242.338 320.094 -233.438C338.317 -224.278 351.699 -211.317 366.699 -196.701C381.415 -181.71 397.747 -165.06 415.419 -139.906C432.783 -115.466 447.382 -83.4893 453.251 -52.5476C459.55 -21.5032 457.119 8.50632 450.329 31.4766C443.342 55.3712 433.458 72.9179 422.311 92.5819C410.879 111.878 398.184 133.269 378.996 156.46C359.514 180.414 333.554 200.137 308.935 207.165C284.175 214.848 260.755 209.831 243.179 199.576C226.568 189.97 213.87 177.534 199.523 163.349C185.437 148.868 169.699 132.637 152.97 108.71C135.605 84.2707 121.006 52.2901 115.134 21.3523C108.838 -9.69609 111.269 -39.7016 118.057 -62.6758C125.043 -86.5705 134.927 -104.117 146.074 -123.781C157.507 -143.074 170.205 -164.492 189.389 -187.655Z"
          stroke="url(#paint11_linear_1178:10461)"
          strokeWidth="2.41306"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.38"
          d="M182.512 -198.696C202.395 -223.756 228.848 -245.154 254.344 -253.734C279.936 -262.973 304.582 -259.398 323.056 -249.649C342.366 -239.6 356.101 -225.577 371.923 -210.092C387.42 -194.157 404.986 -176.749 424.457 -149.828C443.572 -123.757 459.888 -89.0707 466.434 -55.6404C473.478 -22.0836 470.752 10.2328 463.319 34.4592C455.655 59.7403 444.967 77.7847 433.148 98.5271C420.998 118.847 407.719 141.88 387.191 167.41C366.404 193.786 338.209 215.851 311.608 223.677C284.847 232.276 259.667 226.635 241.203 215.421C223.688 204.909 210.634 191.526 195.478 176.504C180.623 161.145 163.668 144.16 145.243 118.551C126.131 92.4794 109.811 57.7929 103.268 24.3586C96.2367 -9.19816 98.948 -41.4987 106.383 -65.737C114.044 -91.0181 124.733 -109.063 136.551 -129.809C148.701 -150.129 161.981 -173.166 182.512 -198.696Z"
          stroke="url(#paint12_linear_1178:10461)"
          strokeWidth="2.53726"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.33"
          d="M175.589 -209.472C196.713 -236.902 225.246 -260.662 252.663 -270.17C280.186 -280.441 306.589 -276.451 325.981 -265.825C346.313 -254.86 360.325 -239.774 376.936 -223.428C393.165 -206.581 411.97 -188.469 433.302 -159.81C454.222 -132.108 472.342 -94.6997 479.594 -58.7491C487.427 -22.6564 484.384 11.959 476.28 37.3902C467.917 64.05 456.397 82.4223 443.946 104.2C431.094 125.475 417.284 150.132 395.443 178.1C373.357 206.983 342.909 231.506 314.31 240.173C285.528 249.728 258.577 243.432 239.296 231.225C220.92 219.77 207.592 205.439 191.667 189.614C176.083 173.395 157.905 155.69 137.742 128.45C116.798 100.747 98.6772 63.335 91.4168 27.3845C83.584 -8.7083 86.6267 -43.3237 94.7306 -68.751C103.097 -95.4107 114.614 -113.787 127.068 -135.564C139.92 -156.844 153.729 -181.501 175.589 -209.472Z"
          stroke="url(#paint13_linear_1178:10461)"
          strokeWidth="2.66146"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.29"
          d="M168.62 -219.991C190.959 -249.866 221.609 -276.084 250.964 -286.583C280.442 -297.924 308.625 -293.52 328.87 -281.977C350.196 -270.064 364.418 -253.892 381.738 -236.724C398.651 -218.98 418.69 -200.24 441.948 -169.856C464.732 -140.565 484.727 -100.376 492.734 -61.8855C501.383 -23.2331 498.012 13.7248 489.221 40.262C480.135 68.2253 467.802 86.8741 454.709 109.584C441.173 131.76 426.882 158.033 403.712 188.528C380.361 219.999 347.614 247.093 316.997 256.633C286.175 267.192 257.48 260.188 237.419 246.987C218.232 234.575 204.708 219.272 188.049 202.67C171.78 185.621 152.37 167.268 130.384 138.4C107.6 109.11 87.6053 68.9206 79.5978 30.43C70.9486 -8.22242 74.3197 -45.1803 83.1105 -71.7215C92.1965 -99.6848 104.53 -118.314 117.626 -141.043C131.155 -163.219 145.447 -189.496 168.62 -219.991Z"
          stroke="url(#paint14_linear_1178:10461)"
          strokeWidth="2.78567"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.24"
          d="M161.609 -230.254C185.141 -262.645 217.945 -291.482 249.252 -302.965C280.704 -315.428 310.667 -310.557 331.719 -298.098C354.012 -285.201 368.304 -267.927 386.332 -249.965C403.88 -231.348 425.152 -212.044 450.398 -179.956C475.101 -149.101 497.093 -106.088 505.851 -65.0377C515.358 -23.8018 511.641 15.4906 502.139 43.0944C492.303 72.3257 479.129 91.0654 465.43 114.699C451.232 137.709 436.509 165.601 412.038 198.7C387.443 232.841 352.358 262.625 319.711 273.082C286.825 284.687 256.377 276.965 235.605 262.708C215.649 249.305 202.014 233.031 184.662 215.701C167.743 197.847 147.107 178.913 123.25 148.43C98.5466 117.575 76.5545 74.5615 67.7969 33.5113C58.2921 -7.74828 62.0067 -47.0288 71.5084 -74.6406C81.3446 -103.872 94.5187 -122.612 108.217 -146.245C122.415 -169.259 137.138 -197.136 161.609 -230.254Z"
          stroke="url(#paint15_linear_1178:10461)"
          strokeWidth="2.90987"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.19"
          d="M154.555 -240.26C179.258 -275.254 214.237 -306.781 247.524 -319.319C280.964 -332.955 312.719 -327.614 334.531 -314.183C357.728 -300.275 372.041 -281.887 390.713 -263.159C408.855 -243.693 431.356 -223.886 458.653 -190.116C485.342 -157.725 509.385 -111.859 518.95 -68.2138C529.35 -24.3669 525.277 17.2719 515.034 45.8752C504.429 76.2915 490.403 95.0549 476.12 119.538C461.274 143.322 446.172 172.826 420.414 208.619C394.596 245.513 357.149 278.102 322.438 289.506C287.474 302.206 255.257 293.721 233.849 278.387C213.168 263.964 199.506 246.718 181.493 228.65C163.972 210.009 142.098 190.55 116.316 158.479C89.6271 126.087 65.5835 80.2259 56.0215 36.5765C45.622 -7.27048 49.6951 -48.9093 59.9379 -77.5086C70.5453 -107.925 84.569 -126.688 98.8517 -151.175C113.71 -174.959 128.797 -204.463 154.555 -240.26Z"
          stroke="url(#paint16_linear_1178:10461)"
          strokeWidth="3.03407"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.14"
          d="M147.451 -250.005C173.305 -287.678 210.493 -322.017 245.776 -335.645C281.229 -350.501 314.765 -344.651 337.302 -330.241C361.373 -315.289 375.602 -295.764 394.876 -276.297C413.554 -256.005 437.291 -235.768 466.703 -200.331C495.437 -166.431 521.623 -117.666 532.019 -71.4056C543.349 -24.916 538.885 19.0534 527.895 48.6047C516.492 80.1666 501.601 98.8232 486.755 124.096C471.279 148.588 455.848 179.711 428.819 218.277C401.197 257.845 362.521 293.678 325.207 305.923C287.519 319.595 254.748 310.62 232.132 294.029C210.773 278.556 197.165 260.326 178.532 241.571C160.457 222.175 137.335 202.255 109.568 168.607C80.8334 134.707 54.6478 85.9418 44.2514 39.6773C32.924 -6.80836 37.3856 -50.7817 48.3756 -80.329C59.7843 -111.891 74.6726 -130.548 89.5187 -155.825C104.994 -180.324 120.428 -211.439 147.451 -250.005Z"
          stroke="url(#paint17_linear_1178:10461)"
          strokeWidth="3.17601"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.1"
          d="M140.314 -259.493C167.298 -299.923 206.73 -337.181 244.026 -351.927C281.512 -368.068 316.856 -361.692 340.044 -346.263C364.952 -330.237 379.009 -309.566 398.844 -289.38C418.022 -268.294 442.987 -247.698 474.572 -210.602C505.403 -175.224 533.82 -123.52 545.066 -74.6169C557.364 -25.4649 552.502 20.8826 540.734 51.2871C528.512 83.9471 512.747 102.375 497.353 128.383C481.263 153.533 465.552 186.257 437.266 227.674C422.685 248.535 405.417 269.376 386.597 286.018C367.823 302.775 347.497 315.337 327.948 322.309C288.07 337.146 253.678 327.365 230.463 309.629C208.471 293.081 195.002 273.864 175.788 254.449C157.176 234.303 132.822 213.995 103.009 178.787C72.1781 143.409 43.7602 91.7053 32.5142 42.8021C20.2227 -6.34205 25.0851 -52.6974 36.8523 -83.1019C49.0744 -115.762 64.8394 -134.19 80.2338 -160.197C96.3181 -185.348 112.029 -218.072 140.314 -259.493Z"
          stroke="url(#paint18_linear_1178:10461)"
          strokeWidth="3.30022"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.05"
          d="M133.128 -268.725C161.826 -311.9 202.337 -352.377 242.209 -368.222C282.373 -385.559 318.334 -378.816 342.745 -362.253C367.883 -345.504 382.795 -322.909 402.558 -302.38C412.436 -291.715 423.613 -280.848 437.037 -267.97C450.359 -255.069 465.928 -240.173 482.226 -220.927C515.163 -183.31 546.018 -130.184 558.116 -77.9034C571.348 -25.2396 566.196 21.9136 553.567 53.9219C540.794 86.8782 523.562 106.432 507.905 132.349C499.771 145.301 491.481 159.956 481.66 177.558C471.82 195.026 460.463 215.437 445.785 236.811C430.578 259.122 412.436 281.559 392.604 299.496C372.82 317.565 351.331 331.133 330.662 338.726C309.959 346.429 290.046 348.151 272.871 345.085C255.6 342.111 241.064 334.349 228.887 325.184C206.308 307.531 193.052 287.318 173.295 267.271C154.199 246.438 128.6 225.766 96.6849 189.022C63.7572 151.392 32.8991 98.2744 20.8035 45.9899C7.56607 -6.662 12.7176 -53.8152 25.3465 -85.8235C38.1199 -118.78 55.352 -138.337 71.0085 -164.25C79.1425 -177.203 87.4332 -191.858 97.2513 -209.46C107.081 -226.928 118.451 -247.342 133.128 -268.725Z"
          stroke="url(#paint19_linear_1178:10461)"
          strokeWidth="3.42442"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1178:10461"
          x1="277.609"
          y1="-54.583"
          x2="277.609"
          y2="24.3967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1178:10461"
          x1="277.611"
          y1="-71.6288"
          x2="277.611"
          y2="41.3512"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1178:10461"
          x1="278.268"
          y1="-88.6742"
          x2="278.268"
          y2="58.3046"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1178:10461"
          x1="278.921"
          y1="-105.71"
          x2="278.921"
          y2="75.2753"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1178:10461"
          x1="279.589"
          y1="-122.781"
          x2="279.589"
          y2="92.1998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1178:10461"
          x1="280.245"
          y1="-139.786"
          x2="280.245"
          y2="109.158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1178:10461"
          x1="280.9"
          y1="-156.832"
          x2="280.9"
          y2="126.089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1178:10461"
          x1="281.54"
          y1="-173.879"
          x2="281.54"
          y2="143.078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1178:10461"
          x1="282.216"
          y1="-190.919"
          x2="282.216"
          y2="160.022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1178:10461"
          x1="282.889"
          y1="-207.956"
          x2="282.889"
          y2="177.013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1178:10461"
          x1="283.533"
          y1="-225.007"
          x2="283.533"
          y2="193.937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1178:10461"
          x1="284.194"
          y1="-242.051"
          x2="284.194"
          y2="210.891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1178:10461"
          x1="284.853"
          y1="-259.095"
          x2="284.853"
          y2="227.851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1178:10461"
          x1="285.505"
          y1="-276.139"
          x2="285.505"
          y2="244.813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1178:10461"
          x1="286.166"
          y1="-293.187"
          x2="286.166"
          y2="261.759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1178:10461"
          x1="286.824"
          y1="-310.225"
          x2="286.824"
          y2="278.719"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1178:10461"
          x1="287.486"
          y1="-327.272"
          x2="287.486"
          y2="295.677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1178:10461"
          x1="288.136"
          y1="-344.313"
          x2="288.136"
          y2="312.605"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1178:10461"
          x1="288.793"
          y1="-361.353"
          x2="288.793"
          y2="329.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1178:10461"
          x1="289.458"
          y1="-378.386"
          x2="289.458"
          y2="346.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function CircularLinesLarge() {
  return (
    <svg
      width="722"
      height="1190"
      viewBox="0 0 722 1190"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          opacity="0.9"
          d="M768.353 209.506C798.304 190.31 834.927 185.119 866.684 194.649C898.442 204.179 925.207 224.201 944.412 253.979C963.618 283.758 968.8 320.544 959.27 352.311C949.74 384.077 929.709 410.834 899.939 430.03C869.08 449.943 831.024 454.699 798.577 444.071C768.117 434.187 742.395 414.391 723.889 385.556C704.675 355.66 699.501 318.992 709.022 287.234C718.543 255.477 738.574 228.711 768.353 209.506Z"
          stroke="url(#paint0_linear_1152:11448)"
          strokeWidth="1.80059"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.86"
          d="M748.949 178.23C787.74 151.728 836.352 144.249 876.732 156.683C917.094 168.963 951.084 193.968 977.568 232.487C1004.07 271.279 1011.55 319.891 999.115 360.27C986.835 400.632 961.83 434.622 923.311 461.098C883.022 488.725 832.331 495.496 791.044 481.392C752.634 468.495 720.087 443.98 694.691 406.849C668.189 368.058 660.71 319.446 673.145 279.066C685.425 238.704 710.42 204.714 748.949 178.23Z"
          stroke="url(#paint1_linear_1152:11448)"
          strokeWidth="1.99753"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.81"
          d="M729.417 147.589C776.976 113.317 837.986 103.252 886.679 118.827C935.355 134.156 975.934 163.781 1010.12 210.904C1044.38 258.463 1054.44 319.473 1038.87 368.167C1023.54 416.842 993.905 457.413 946.791 491.603C897.226 527.463 833.393 536.484 783.647 518.649C737.631 502.557 698.757 473.595 666.074 428.287C631.812 380.728 621.746 319.718 637.321 271.034C652.669 222.331 682.293 181.743 729.417 147.589Z"
          stroke="url(#paint2_linear_1152:11448)"
          strokeWidth="2.22261"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.76"
          d="M709.758 117.456C766.03 74.9706 839.819 62.028 896.509 80.9699C953.217 99.567 999.75 133.557 1042.11 189.112C1084.59 245.385 1097.55 319.183 1078.6 375.873C1060 432.571 1025.96 479.105 970.453 521.454C941.354 542.819 906.919 558.076 873.065 563.658C840.709 569.143 807.495 566.428 776.459 555.762C723.145 536.275 678.436 503.12 638.102 449.816C595.616 393.544 582.665 319.745 601.607 263.056C620.204 206.357 654.194 159.815 709.758 117.456Z"
          stroke="url(#paint3_linear_1152:11448)"
          strokeWidth="2.41955"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.71"
          d="M689.946 87.9586C722.102 63.4984 760.386 45.1918 798.269 37.7675C834.138 30.4606 871.271 32.3338 906.221 43.2132C970.662 65.3045 1022.52 103.397 1073.49 167.23C1097.94 199.387 1116.24 237.67 1123.68 275.554C1130.99 311.419 1129.11 348.55 1118.23 383.497C1096.14 447.937 1058.05 499.798 994.224 550.752C960.642 576.356 920.362 595.098 880.881 601.932C843.566 608.654 805.143 605.525 769.407 592.856C709.132 569.803 659.177 532.763 610.683 471.544C586.232 439.378 567.926 401.095 560.492 363.211C553.181 327.346 555.054 290.215 565.938 255.269C588.02 190.801 626.113 138.912 689.946 87.9586Z"
          stroke="url(#paint4_linear_1152:11448)"
          strokeWidth="2.61649"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.67"
          d="M670.013 59.0511C706.317 30.3886 750.237 8.45155 793.521 -0.452164C834.11 -9.19719 876.283 -7.13158 915.822 5.53808C952.762 17.4732 983.531 35.6709 1014.32 58.1798C1044.79 81.0245 1075.29 108.235 1104.27 145.166C1132.92 181.47 1154.87 225.39 1163.77 268.674C1172.51 309.263 1170.45 351.435 1157.78 390.975C1145.85 427.915 1127.64 458.674 1105.1 489.47C1082.24 519.929 1055.04 550.434 1018.11 579.405C980.209 609.438 933.857 631.938 888.721 640.125C846.48 648.133 802.857 644.535 762.499 629.715C728.1 617.062 698.966 599.2 669.613 577.182C640.57 554.927 611.417 528.506 583.853 493.264C555.199 456.959 533.253 413.03 524.35 369.755C515.605 329.167 517.67 286.994 530.34 247.454C542.275 210.514 560.473 179.746 582.982 148.96C605.872 118.545 633.082 88.0313 670.013 59.0511Z"
          stroke="url(#paint5_linear_1152:11448)"
          strokeWidth="2.81343"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.62"
          d="M649.946 30.7334C690.353 -2.29475 739.991 -28.1346 788.721 -38.6085C833.998 -48.8799 881.218 -46.6207 925.308 -32.0736C966.087 -18.4594 999.297 1.98918 1033.23 26.8669C1066.76 52.144 1101.01 81.8594 1134.47 123.074C1167.5 163.481 1193.34 213.119 1203.81 261.849C1214.08 307.126 1211.82 354.345 1197.28 398.436C1183.66 439.215 1163.21 472.425 1138.28 506.36C1113 539.888 1083.29 574.132 1042.07 607.578C999.878 642.24 947.372 668.76 896.536 678.372C849.42 687.782 800.605 683.717 755.693 666.645C717.89 652.241 686.414 632.265 654.04 608.004C622.092 583.426 589.29 554.555 557.506 515.282C524.468 474.875 498.638 425.238 488.164 376.508C477.892 331.231 480.151 284.01 494.699 239.921C508.313 199.141 528.752 165.932 553.639 131.996C579.062 98.4415 608.75 64.1881 649.946 30.7334Z"
          stroke="url(#paint6_linear_1152:11448)"
          strokeWidth="3.01037"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.57"
          d="M629.752 3.01459C674.225 -34.5789 729.644 -64.5665 783.874 -76.7013C838.258 -89.5804 891.426 -84.6157 934.683 -69.6038C979.156 -54.2469 1014.55 -31.4839 1051.51 -4.36433C1087.96 23.2816 1125.94 55.3658 1164.06 100.774C1201.65 145.247 1231.64 200.666 1243.77 254.905C1256.65 309.29 1251.69 362.449 1236.67 405.715C1221.31 450.188 1198.55 485.585 1171.43 522.534C1143.78 558.975 1111.7 596.958 1066.3 635.078C1019.87 674.541 961.113 705.364 904.514 716.473C852.566 727.354 798.571 722.804 749.176 703.385C708.106 687.166 674.57 665.066 639.354 638.609C604.592 611.78 568.161 580.594 531.992 537.337C494.399 492.864 464.411 437.436 452.276 383.206C439.388 328.821 444.362 275.653 459.365 232.396C474.731 187.923 497.485 152.526 524.613 115.568C552.259 79.1181 584.334 41.1254 629.752 3.01459Z"
          stroke="url(#paint7_linear_1152:11448)"
          strokeWidth="3.20731"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.52"
          d="M609.42 -24.114C657.823 -66.4362 719.196 -100.835 778.99 -114.712C838.965 -129.525 897.37 -123.788 943.949 -107.061C992.053 -89.8708 1029.34 -64.8388 1069.2 -35.4683C1108.42 -5.51698 1150.16 28.7818 1193.13 78.3649C1235.44 126.777 1269.84 188.141 1283.73 247.935C1298.54 307.91 1292.81 366.315 1276.07 412.894C1258.89 460.998 1233.85 498.282 1204.48 538.145C1174.53 577.363 1140.23 619.095 1090.65 662.053C1040.07 706.526 974.935 741.923 912.527 754.629C855.787 767.072 796.606 762.008 742.803 740.108C698.602 721.955 663.242 697.758 625.24 669.196C587.801 640.152 547.72 606.797 506.978 559.592C464.655 511.18 430.257 449.77 416.37 390.013C401.567 330.038 407.294 271.642 424.021 225.054C441.212 176.95 466.253 139.674 495.614 99.8482C525.511 60.5847 559.837 18.8434 609.42 -24.114Z"
          stroke="url(#paint8_linear_1152:11448)"
          strokeWidth="3.40425"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.48"
          d="M588.955 -50.6525C641.27 -97.8485 708.642 -136.949 774.054 -152.687C839.684 -169.523 903.344 -163.033 953.099 -144.464C1004.65 -125.404 1043.6 -97.9937 1086.16 -66.4813C1128.01 -34.2519 1173.49 2.09813 1221.5 55.8108C1268.7 108.126 1307.79 175.498 1323.52 240.91C1340.36 306.54 1333.87 370.2 1315.3 419.955C1296.24 471.508 1268.83 510.454 1237.32 553.012C1205.09 594.862 1168.74 640.334 1115.04 688.328C1060.35 737.993 988.741 778.182 920.48 792.595C851.864 808.261 786.597 798.041 736.506 776.648C689.31 756.59 652.388 730.197 611.718 699.583C571.719 668.397 527.981 633 482.492 581.883C435.295 529.577 396.195 462.196 380.457 396.784C363.621 331.154 370.111 267.494 388.68 217.739C407.74 166.195 435.15 127.24 466.663 84.673C498.892 42.8228 535.242 -2.6487 588.955 -50.6525Z"
          stroke="url(#paint9_linear_1152:11448)"
          strokeWidth="3.62932"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.43"
          d="M568.36 -76.5927C624.514 -128.926 697.959 -172.9 769.079 -190.589C840.409 -209.558 909.36 -202.234 962.138 -181.785C1017.04 -160.738 1057.36 -130.959 1102.55 -97.3771C1146.88 -62.9331 1196.09 -24.6771 1249.33 33.1199C1301.64 89.2741 1345.62 162.746 1363.3 233.839C1382.28 305.169 1374.96 374.12 1354.5 426.898C1333.45 481.8 1303.67 522.116 1270.09 567.297C1235.65 611.634 1197.4 660.782 1139.6 714.068C1080.9 769.105 1002.69 814.423 928.52 830.569C853.923 848.222 783.365 836.696 730.415 813.134C680.369 791.061 642.113 762.489 598.892 729.896C556.452 696.623 509.038 659.329 458.638 604.355C406.323 548.201 362.34 474.72 344.651 403.636C325.682 332.297 333.006 263.355 353.455 210.568C374.502 155.666 404.281 115.35 437.863 70.1687C472.307 25.8408 510.563 -23.3701 568.36 -76.5927Z"
          stroke="url(#paint10_linear_1152:11448)"
          strokeWidth="3.82626"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.38"
          d="M547.639 -101.96C607.542 -159.539 687.24 -208.705 764.051 -228.418C841.153 -249.647 915.405 -241.433 971.06 -219.033C1029.24 -195.944 1070.62 -163.723 1118.28 -128.145C1164.97 -91.5315 1217.9 -51.5329 1276.55 10.3212C1334.14 70.2238 1383.3 149.922 1403.02 226.733C1424.24 303.835 1416.03 378.087 1393.64 433.751C1370.55 491.839 1338.35 533.298 1302.74 580.957C1266.14 627.645 1226.13 680.568 1164.28 739.227C1101.66 799.829 1016.71 850.528 936.571 868.508C855.948 888.267 780.089 875.306 724.461 849.539C671.692 825.387 632.365 794.637 586.703 760.121C541.949 724.833 490.868 685.805 435.358 626.964C377.779 567.062 328.614 487.364 308.9 410.543C287.716 333.441 295.885 259.226 318.285 203.534C341.366 145.447 373.568 103.987 409.174 56.3191C445.778 9.63136 485.785 -43.3008 547.639 -101.96Z"
          stroke="url(#paint11_linear_1152:11448)"
          strokeWidth="4.0232"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.33"
          d="M526.783 -126.72C590.425 -189.745 676.385 -244.338 758.987 -266.184C841.907 -289.782 921.451 -280.615 979.874 -256.2C1041.13 -231.005 1083.34 -196.343 1133.39 -158.786C1182.28 -120.076 1238.93 -78.4617 1303.2 -12.6142C1366.23 51.0369 1420.82 136.988 1442.67 219.59C1466.27 302.519 1457.1 382.053 1432.68 440.486C1407.49 501.741 1372.78 543.954 1335.27 593.991C1296.55 642.875 1254.94 699.529 1189.14 763.788C1122.61 830.153 1030.87 886.497 944.713 906.411C857.999 928.366 776.804 913.898 718.716 885.853C663.352 859.532 623.199 826.604 575.222 790.245C528.271 752.978 473.506 712.299 412.759 649.709C349.662 586.058 295.069 500.098 273.195 417.496C249.597 334.567 258.764 255.033 283.179 196.609C308.383 135.354 343.081 93.1322 380.602 43.0953C419.321 -5.79798 460.926 -62.4514 526.783 -126.72Z"
          stroke="url(#paint12_linear_1152:11448)"
          strokeWidth="4.22014"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.29"
          d="M505.789 -150.889C573.089 -219.532 665.43 -279.771 753.868 -303.895C842.678 -329.953 927.586 -319.833 988.577 -293.312C1052.83 -265.939 1095.68 -228.781 1147.85 -189.336C1198.81 -148.566 1259.18 -105.508 1329.25 -35.6947C1397.89 31.605 1458.13 123.946 1482.26 212.384C1508.31 301.194 1498.16 386.111 1471.67 447.084C1444.3 511.334 1407.14 554.183 1367.7 606.362C1326.92 657.315 1283.86 717.681 1214.06 787.749C1143.71 860.058 1045.05 922.312 952.808 944.231C859.95 968.491 773.5 952.399 713.062 922.067C655.256 893.55 614.513 858.389 564.322 820.241C515.31 781.069 456.833 738.901 390.595 672.572C321.952 605.273 261.713 512.932 237.589 424.494C211.531 335.684 221.687 250.767 248.172 189.784C275.545 125.534 312.703 82.731 352.157 30.5068C392.918 -20.4467 435.976 -80.8213 505.789 -150.889Z"
          stroke="url(#paint13_linear_1152:11448)"
          strokeWidth="4.41708"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.24"
          d="M484.669 -174.469C555.563 -248.894 654.393 -315.15 748.713 -341.534C843.468 -370.169 933.739 -358.978 997.163 -330.352C1064.33 -300.718 1107.38 -261.028 1161.7 -219.759C1214.56 -176.983 1278.65 -132.628 1354.71 -58.9024C1429.13 11.9914 1495.39 110.822 1521.77 205.141C1550.42 299.887 1539.22 390.168 1510.59 453.592C1480.96 520.755 1441.27 563.813 1400 618.115C1357.22 670.984 1312.87 735.071 1239.14 811.12C1165.05 889.565 1059.34 957.999 960.986 982.024C861.91 1008.69 770.178 990.946 707.598 958.19C647.477 927.395 606.398 890.001 554.12 850.184C503.148 809.159 440.976 765.657 369.102 695.617C294.678 624.723 228.422 525.893 202.037 431.573C173.402 336.773 184.593 246.519 213.219 183.077C242.853 115.913 282.543 72.8562 323.812 18.5535C366.588 -34.3242 410.943 -98.3746 484.669 -174.469Z"
          stroke="url(#paint14_linear_1152:11448)"
          strokeWidth="4.61402"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.19"
          d="M463.413 -197.459C537.837 -277.865 643.22 -350.302 743.503 -379.11C844.248 -410.441 939.92 -398.17 1005.63 -367.311C1075.52 -335.354 1118.64 -293.104 1174.89 -250.074C1229.55 -205.347 1297.34 -159.839 1379.58 -82.2467C1459.98 -7.82216 1532.42 97.5611 1561.24 197.844C1592.57 298.589 1580.3 394.261 1549.44 459.981C1517.49 529.868 1475.23 572.979 1432.2 629.233C1387.47 683.881 1341.98 751.671 1264.37 833.91C1186.59 918.681 1073.78 993.559 969.2 1019.76C863.862 1048.94 766.801 1029.45 702.306 994.213C639.998 961.076 598.838 921.449 544.572 879.935C491.785 837.105 425.883 792.395 348.209 718.706C267.803 644.282 195.367 538.907 166.559 438.616C135.228 337.871 147.499 242.199 178.358 176.487C210.315 106.601 252.564 63.4892 295.595 7.22607C340.358 -47.4215 385.812 -115.211 463.413 -197.459Z"
          stroke="url(#paint15_linear_1152:11448)"
          strokeWidth="4.81096"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.14"
          d="M442.011 -219.85C519.902 -306.41 631.939 -385.309 738.238 -416.621C845.047 -450.757 946.082 -437.315 1013.98 -404.205C1086.5 -369.852 1129.37 -324.989 1187.44 -280.261C1243.71 -233.637 1315.22 -187.14 1403.83 -105.718C1490.4 -27.826 1569.29 84.2191 1600.61 190.51C1634.75 297.327 1621.29 398.354 1588.18 466.253C1553.83 538.771 1508.97 581.638 1464.24 639.707C1417.62 695.979 1371.13 767.49 1289.7 856.101C1206.48 947.017 1089.96 1029.35 977.541 1057.48C863.998 1088.9 765.267 1068.27 697.133 1030.15C632.783 994.603 591.786 952.717 535.65 909.623C481.193 865.059 411.533 819.288 327.878 741.977C241.31 664.086 162.42 552.041 131.098 445.741C96.9716 338.932 110.413 237.897 143.523 170.007C177.895 97.4885 222.749 54.6218 267.476 -3.45654C314.101 -59.7469 360.598 -131.24 442.011 -219.85Z"
          stroke="url(#paint16_linear_1152:11448)"
          strokeWidth="5.03604"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.1"
          d="M420.51 -241.651C501.805 -334.545 620.602 -420.152 732.965 -454.033C845.9 -491.118 952.381 -476.469 1022.24 -441.018C1097.28 -404.196 1139.63 -356.7 1199.39 -310.321C1257.17 -261.873 1332.38 -214.549 1427.54 -129.315C1520.42 -48.0292 1606.04 70.7686 1639.92 183.131C1676.97 296.066 1662.32 402.557 1626.87 472.416C1590.05 547.458 1542.55 589.798 1496.17 649.555C1447.69 707.343 1400.36 782.53 1315.15 877.694C1271.22 925.625 1219.19 973.511 1162.49 1011.75C1105.93 1050.25 1044.7 1079.11 985.8 1095.13C865.659 1129.22 762.045 1106.75 692.104 1066C625.849 1027.98 585.269 983.821 527.381 939.212C471.309 892.923 397.937 846.263 308.119 765.367C215.234 684.081 129.619 565.283 95.7373 452.92C58.7066 340.004 73.3555 233.495 108.807 163.636C145.629 88.5942 193.125 46.2539 239.504 -13.5035C287.961 -71.2914 335.293 -146.478 420.51 -241.651Z"
          stroke="url(#paint17_linear_1152:11448)"
          strokeWidth="5.23298"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.05"
          d="M398.863 -262.862C485.322 -362.064 607.369 -455.068 727.492 -491.472C848.496 -531.307 956.838 -515.814 1030.38 -477.758C1106.11 -439.275 1151.04 -387.36 1210.58 -340.191C1240.34 -315.685 1274.01 -290.717 1314.46 -261.128C1354.59 -231.486 1401.5 -197.259 1450.6 -153.04C1549.83 -66.6081 1642.79 55.4572 1679.24 175.58C1719.1 296.584 1703.58 404.926 1665.53 478.47C1627.05 554.192 1575.13 599.119 1527.96 658.668C1503.46 688.428 1478.48 722.101 1448.89 762.544C1419.25 802.679 1385.03 849.576 1340.81 898.687C1295 949.949 1240.34 1001.5 1180.59 1042.72C1120.99 1084.23 1056.25 1115.41 993.977 1132.85C931.606 1150.55 871.613 1154.51 819.87 1147.46C767.836 1140.63 724.043 1122.8 687.358 1101.74C619.332 1061.18 579.397 1014.73 519.875 968.673C462.342 920.805 385.221 873.31 289.069 788.883C189.866 702.424 96.8991 580.377 60.4584 460.245C20.5777 339.269 36.098 230.927 74.1452 157.382C112.628 81.66 164.544 36.724 211.713 -22.8156C236.218 -52.5763 261.196 -86.2489 290.775 -126.692C320.39 -166.827 354.644 -213.733 398.863 -262.862Z"
          stroke="url(#paint18_linear_1152:11448)"
          strokeWidth="5.42992"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1152:11448"
          x1="834.148"
          y1="189.997"
          x2="834.148"
          y2="449.587"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1152:11448"
          x1="836.13"
          y1="150.833"
          x2="836.13"
          y2="488.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1152:11448"
          x1="838.095"
          y1="111.69"
          x2="838.095"
          y2="527.533"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1152:11448"
          x1="840.105"
          y1="72.4678"
          x2="840.105"
          y2="566.419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1152:11448"
          x1="842.085"
          y1="33.3945"
          x2="842.085"
          y2="605.385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1152:11448"
          x1="844.06"
          y1="-5.77148"
          x2="844.06"
          y2="644.285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1152:11448"
          x1="845.985"
          y1="-44.9399"
          x2="845.985"
          y2="683.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1152:11448"
          x1="848.022"
          y1="-84.0913"
          x2="848.022"
          y2="722.252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1152:11448"
          x1="850.052"
          y1="-123.236"
          x2="850.052"
          y2="761.292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1152:11448"
          x1="851.991"
          y1="-162.414"
          x2="851.991"
          y2="800.177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1152:11448"
          x1="853.981"
          y1="-201.574"
          x2="853.981"
          y2="839.131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1152:11448"
          x1="855.968"
          y1="-240.737"
          x2="855.968"
          y2="878.099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1152:11448"
          x1="857.931"
          y1="-279.896"
          x2="857.931"
          y2="917.072"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1152:11448"
          x1="859.923"
          y1="-319.067"
          x2="859.923"
          y2="956.009"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1152:11448"
          x1="861.908"
          y1="-358.216"
          x2="861.908"
          y2="994.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1152:11448"
          x1="863.898"
          y1="-397.383"
          x2="863.898"
          y2="1033.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1152:11448"
          x1="865.856"
          y1="-436.539"
          x2="865.856"
          y2="1072.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1152:11448"
          x1="867.835"
          y1="-475.69"
          x2="867.835"
          y2="1111.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1152:11448"
          x1="869.84"
          y1="-514.826"
          x2="869.84"
          y2="1150.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function CircularLinesFull() {
  return (
    <svg
      width="640"
      height="628"
      viewBox="0 0 640 628"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          opacity="0.8"
          d="M287.079 308.977C288.441 304.88 291.206 301.373 294.904 299.055C298.601 296.737 303.002 295.75 307.356 296.264C311.71 296.778 315.749 298.759 318.783 301.872C321.818 304.984 323.66 309.034 323.997 313.332C324.334 317.63 323.144 321.91 320.63 325.442C318.117 328.975 314.435 331.541 310.212 332.704C305.989 333.867 301.486 333.555 297.472 331.821C293.457 330.087 290.178 327.037 288.193 323.193C287.064 321.013 286.384 318.634 286.192 316.195C286.001 313.755 286.303 311.302 287.079 308.977V308.977Z"
          stroke="url(#paint0_linear_2361_4244)"
          strokeWidth="0.887155"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.95"
          d="M289.509 286.456C293.27 284.254 297.453 282.84 301.796 282.301C306.14 281.762 310.549 282.11 314.749 283.324C323.104 285.787 330.195 291.279 334.586 298.687C336.825 302.385 338.263 306.497 338.811 310.766C339.359 315.035 339.005 319.369 337.771 323.497C335.268 331.711 329.68 338.681 322.142 342.995C318.296 345.25 314.01 346.681 309.563 347.196C305.116 347.71 300.609 347.297 296.336 345.983C288.209 343.439 281.334 338.015 277.048 330.767C274.81 327.069 273.372 322.957 272.824 318.688C272.277 314.419 272.631 310.085 273.866 305.957C276.369 297.739 281.962 290.766 289.509 286.456V286.456Z"
          stroke="url(#paint1_linear_2361_4244)"
          strokeWidth="1.77431"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.9"
          d="M281.708 274.976C292.682 268.062 306.1 266.192 317.736 269.625C329.372 273.057 339.179 280.268 346.216 290.992C353.252 301.717 355.151 314.966 351.659 326.406C348.168 337.847 340.828 347.483 329.921 354.397C318.614 361.568 304.67 363.281 292.782 359.453C281.621 355.894 272.197 348.765 265.416 338.38C258.376 327.612 256.481 314.407 259.969 302.969C263.457 291.532 270.797 281.892 281.708 274.976Z"
          stroke="url(#paint2_linear_2361_4244)"
          strokeWidth="1.13556"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.86"
          d="M274.602 263.712C288.815 254.167 306.626 251.473 321.421 255.951C336.21 260.374 348.664 269.38 358.367 283.252C368.078 297.223 370.818 314.73 366.262 329.273C361.763 343.809 352.601 356.051 338.488 365.586C323.726 375.536 305.153 377.974 290.025 372.895C275.952 368.25 264.027 359.421 254.722 346.048C245.012 332.078 242.271 314.57 246.827 300.027C251.327 285.491 260.485 273.25 274.602 263.712Z"
          stroke="url(#paint3_linear_2361_4244)"
          strokeWidth="1.25976"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.81"
          d="M267.442 252.676C284.868 240.333 307.222 236.708 325.063 242.317C342.898 247.838 357.766 258.508 370.29 275.479C382.844 292.607 386.532 314.58 380.825 332.117C375.208 349.647 364.351 364.259 347.088 376.572C328.927 389.487 305.539 392.736 287.312 386.313C270.452 380.518 256.209 370.087 244.234 353.769C231.68 336.641 227.992 314.668 233.699 297.135C239.322 279.594 250.177 264.977 267.442 252.676Z"
          stroke="url(#paint4_linear_2361_4244)"
          strokeWidth="1.4017"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.76"
          d="M260.243 241.824C280.861 226.523 307.897 221.861 328.668 228.683C349.446 235.381 366.496 247.623 382.016 267.631C397.582 287.897 402.328 314.475 395.387 334.892C388.57 355.312 376.1 372.071 355.761 387.323C345.099 395.018 332.483 400.512 320.078 402.523C308.223 404.498 296.053 403.52 284.682 399.679C265.148 392.661 248.767 380.72 233.988 361.523C218.422 341.256 213.676 314.678 220.616 294.261C227.43 273.841 239.884 257.079 260.243 241.824Z"
          stroke="url(#paint5_linear_2361_4244)"
          strokeWidth="1.52591"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.71"
          d="M252.982 231.2C264.764 222.391 278.791 215.798 292.672 213.124C305.814 210.493 319.419 211.167 332.225 215.085C355.836 223.042 374.838 236.761 393.511 259.75C402.469 271.331 409.177 285.119 411.901 298.762C414.579 311.679 413.893 325.052 409.905 337.638C401.811 360.846 387.854 379.524 364.469 397.875C352.165 407.096 337.406 413.846 322.94 416.307C309.268 418.728 295.19 417.601 282.097 413.038C260.012 404.736 241.709 391.396 223.941 369.348C214.982 357.764 208.274 343.976 205.551 330.332C202.872 317.416 203.558 304.043 207.546 291.457C215.637 268.239 229.594 249.551 252.982 231.2Z"
          stroke="url(#paint6_linear_2361_4244)"
          strokeWidth="1.65011"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.67"
          d="M245.675 220.789C258.977 210.467 275.069 202.566 290.928 199.359C305.8 196.21 321.252 196.954 335.739 201.517C349.274 205.815 360.548 212.369 371.828 220.476C382.995 228.703 394.168 238.503 404.787 251.803C415.285 264.879 423.326 280.696 426.588 296.285C429.791 310.903 429.034 326.091 424.394 340.331C420.021 353.635 413.35 364.713 405.089 375.804C396.716 386.774 386.749 397.76 373.218 408.194C359.33 419.011 342.347 427.114 325.81 430.062C310.332 432.946 294.349 431.65 279.562 426.313C266.958 421.756 256.284 415.323 245.529 407.393C234.887 399.378 224.206 389.863 214.106 377.17C203.608 364.095 195.567 348.274 192.304 332.689C189.1 318.071 189.857 302.883 194.499 288.642C198.872 275.339 205.54 264.257 213.787 253.17C222.174 242.216 232.144 231.227 245.675 220.789Z"
          stroke="url(#paint7_linear_2361_4244)"
          strokeWidth="1.77431"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.62"
          d="M238.327 210.591C253.132 198.696 271.319 189.39 289.174 185.617C305.763 181.918 323.065 182.732 339.219 187.971C354.161 192.874 366.329 200.239 378.763 209.198C391.047 218.302 403.597 229.004 415.855 243.847C427.957 258.4 437.424 276.277 441.262 293.827C445.024 310.133 444.196 327.139 438.868 343.018C433.879 357.705 426.387 369.665 417.252 381.887C407.99 393.962 397.103 406.295 382.002 418.34C366.541 430.824 347.304 440.375 328.677 443.837C311.414 447.226 293.528 445.762 277.073 439.613C263.222 434.426 251.689 427.231 239.827 418.494C228.121 409.642 216.103 399.244 204.457 385.1C192.352 370.548 182.888 352.671 179.05 335.121C175.287 318.814 176.115 301.808 181.445 285.929C186.433 271.243 193.922 259.282 203.041 247.06C212.355 234.976 223.233 222.639 238.327 210.591Z"
          stroke="url(#paint8_linear_2361_4244)"
          strokeWidth="1.89851"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.57"
          d="M230.927 200.608C247.222 187.069 267.528 176.269 287.397 171.898C307.324 167.26 326.805 169.048 342.654 174.455C358.949 179.985 371.918 188.183 385.46 197.95C398.815 207.907 412.729 219.462 426.696 235.816C440.47 251.833 451.457 271.792 455.903 291.326C460.622 310.912 458.803 330.058 453.303 345.64C447.673 361.657 439.336 374.405 429.399 387.712C419.266 400.836 407.514 414.516 390.877 428.245C373.867 442.457 352.338 453.558 331.6 457.559C312.566 461.478 292.782 459.839 274.684 452.845C259.636 447.004 247.349 439.045 234.446 429.516C221.709 419.854 208.361 408.622 195.109 393.043C181.334 377.026 170.347 357.064 165.901 337.533C161.179 317.947 163.001 298.798 168.498 283.219C174.128 267.202 182.465 254.454 192.405 241.144C202.534 228.017 214.287 214.334 230.927 200.608Z"
          stroke="url(#paint9_linear_2361_4244)"
          strokeWidth="2.02271"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.52"
          d="M223.476 190.838C241.211 175.595 263.698 163.207 285.606 158.209C307.581 152.874 328.98 154.94 346.047 160.964C363.672 167.155 377.333 176.171 391.938 186.748C406.308 197.535 421.602 209.888 437.345 227.745C452.848 245.181 465.452 267.281 470.543 288.816C475.967 310.416 473.868 331.45 467.736 348.225C461.441 365.55 452.266 378.978 441.505 393.334C430.531 407.459 417.964 422.488 399.797 437.959C381.264 453.976 357.4 466.725 334.534 471.301C313.744 475.782 292.06 473.958 272.347 466.071C256.152 459.533 243.196 450.819 229.272 440.532C215.555 430.072 200.869 418.059 185.941 401.058C170.434 383.623 157.831 361.506 152.743 339.985C147.319 318.385 149.417 297.354 155.546 280.575C161.845 263.251 171.02 249.826 181.778 235.482C192.732 221.342 205.309 206.309 223.476 190.838Z"
          stroke="url(#paint10_linear_2361_4244)"
          strokeWidth="2.14691"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.48"
          d="M215.979 181.28C235.147 164.282 259.832 150.2 283.799 144.532C307.845 138.469 331.17 140.806 349.4 147.494C368.289 154.358 382.559 164.23 398.155 175.579C413.489 187.186 430.15 200.278 447.742 219.622C465.034 238.464 479.357 262.728 485.124 286.286C491.292 309.922 488.915 332.849 482.111 350.768C475.127 369.335 465.084 383.361 453.538 398.689C441.729 413.761 428.411 430.137 408.734 447.423C388.698 465.309 362.46 479.783 337.449 484.974C312.308 490.616 288.394 486.935 270.041 479.231C252.748 472.007 239.22 462.501 224.319 451.476C209.663 440.244 193.638 427.496 176.971 409.086C159.678 390.249 145.352 365.981 139.585 342.423C133.417 318.787 135.794 295.86 142.598 277.94C149.582 259.377 159.625 245.348 171.171 230.017C182.98 214.945 196.298 198.568 215.979 181.28Z"
          stroke="url(#paint11_linear_2361_4244)"
          strokeWidth="2.28886"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.43"
          d="M208.435 171.938C229.01 153.09 255.92 137.253 281.978 130.882C308.113 124.05 333.377 126.688 352.714 134.053C372.83 141.633 387.602 152.358 404.16 164.452C420.405 176.857 438.432 190.635 457.94 211.45C477.108 231.674 493.223 258.135 499.701 283.739C506.655 309.428 503.971 334.261 496.475 353.269C488.764 373.042 477.853 387.562 465.548 403.833C452.928 419.801 438.914 437.502 417.734 456.693C396.229 476.514 367.573 492.835 340.397 498.65C313.065 505.008 287.212 500.857 267.811 492.371C249.475 484.422 235.458 474.131 219.622 462.393C204.072 450.41 186.699 436.979 168.233 417.18C149.065 396.956 132.95 370.492 126.468 344.891C119.518 319.199 122.202 294.369 129.694 275.358C137.406 255.585 148.317 241.065 160.621 224.793C173.241 208.829 187.258 191.106 208.435 171.938Z"
          stroke="url(#paint12_linear_2361_4244)"
          strokeWidth="2.41306"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.38"
          d="M200.84 162.802C222.788 142.064 251.989 124.358 280.133 117.258C308.383 109.612 335.588 112.57 355.98 120.638C377.297 128.953 392.458 140.558 409.923 153.371C427.029 166.557 446.42 180.963 467.913 203.239C489.013 224.813 507.024 253.516 514.25 281.18C522.025 308.948 519.016 335.69 510.812 355.737C502.352 376.657 490.553 391.589 477.507 408.753C464.095 425.568 449.437 444.628 426.777 465.754C403.831 487.579 372.708 505.839 343.343 512.314C313.803 519.43 286.009 514.762 265.627 505.482C246.292 496.784 231.883 485.71 215.153 473.279C198.755 460.57 180.039 446.514 159.7 425.322C138.603 403.749 120.589 375.046 113.366 347.379C105.604 319.611 108.597 292.882 116.804 272.825C125.261 251.905 137.06 236.973 150.106 219.805C163.518 202.991 178.176 183.928 200.84 162.802Z"
          stroke="url(#paint13_linear_2361_4244)"
          strokeWidth="2.53726"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.33"
          d="M193.202 153.884C216.52 131.186 248.016 111.524 278.281 103.657C308.663 95.1577 337.808 98.4592 359.214 107.252C381.657 116.326 397.124 128.81 415.461 142.336C433.375 156.277 454.133 171.264 477.681 194.979C500.773 217.903 520.776 248.858 528.78 278.607C537.427 308.474 534.068 337.118 525.122 358.162C515.891 380.223 503.174 395.426 489.43 413.447C475.243 431.053 459.999 451.456 435.89 474.599C411.51 498.5 377.9 518.793 346.331 525.964C314.559 533.872 284.809 528.661 263.526 518.561C243.241 509.081 228.529 497.222 210.95 484.128C193.747 470.706 173.681 456.055 151.424 433.514C128.305 410.59 108.302 379.632 100.288 349.883C91.6417 320.016 95.0004 291.372 103.946 270.331C113.181 248.27 125.894 233.064 139.642 215.043C153.828 197.434 169.072 177.03 193.202 153.884Z"
          stroke="url(#paint14_linear_2361_4244)"
          strokeWidth="2.66146"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.29"
          d="M185.505 145.18C210.163 120.458 243.997 98.7632 276.4 90.0749C308.94 80.6902 340.05 84.3349 362.398 93.8862C385.939 103.745 401.638 117.127 420.757 131.333C439.426 146.016 461.547 161.523 487.22 186.667C512.37 210.905 534.442 244.161 543.281 276.012C552.828 307.997 549.107 338.579 539.403 360.539C529.374 383.678 515.759 399.11 501.307 417.902C486.365 436.253 470.589 457.994 445.013 483.229C419.237 509.271 383.089 531.691 349.292 539.585C315.269 548.323 283.593 542.527 261.449 531.603C240.269 521.333 225.341 508.669 206.951 494.931C188.993 480.823 167.567 465.636 143.298 441.748C118.147 417.51 96.0758 384.254 87.2367 352.403C77.6892 320.418 81.4104 289.836 91.1142 267.873C101.144 244.733 114.758 229.318 129.214 210.509C144.149 192.158 159.925 170.415 185.505 145.18Z"
          stroke="url(#paint15_linear_2361_4244)"
          strokeWidth="2.78567"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.24"
          d="M177.77 136.687C203.745 109.884 239.956 86.0216 274.515 76.5193C309.233 66.2064 342.308 70.2367 365.547 80.5464C390.155 91.2189 405.931 105.513 425.831 120.376C445.202 135.782 468.683 151.756 496.551 178.309C523.82 203.841 548.096 239.434 557.763 273.403C568.258 307.526 564.155 340.041 553.666 362.883C542.808 387.071 528.266 402.579 513.145 422.136C497.472 441.176 481.22 464.257 454.207 491.646C427.058 519.898 388.33 544.544 352.291 553.197C315.99 562.8 282.379 556.41 259.45 544.613C237.422 533.522 222.371 520.055 203.216 505.715C184.54 490.94 161.761 475.273 135.426 450.048C108.157 424.515 83.881 388.922 74.2138 354.953C63.7219 320.81 67.8222 288.306 78.3108 265.457C89.1685 241.268 103.711 225.761 118.832 206.204C134.505 187.16 150.757 164.093 177.77 136.687Z"
          stroke="url(#paint16_linear_2361_4244)"
          strokeWidth="2.90987"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.19"
          d="M169.982 128.408C197.251 99.4496 235.863 73.3616 272.606 62.9865C309.519 51.7027 344.573 56.1221 368.65 67.2359C394.256 78.7452 410.055 93.9613 430.667 109.459C450.693 125.567 475.531 141.957 505.663 169.901C535.124 196.705 561.664 234.659 572.223 270.775C583.702 307.059 579.206 341.515 567.9 365.184C556.194 390.353 540.71 405.88 524.944 426.14C508.556 445.821 491.886 470.235 463.453 499.854C434.953 530.384 393.617 557.351 355.301 566.788C316.706 577.297 281.143 570.276 257.512 557.586C234.682 545.652 219.601 531.381 199.718 516.429C180.377 501.004 156.231 484.902 127.771 458.363C98.3108 431.559 71.7701 393.609 61.215 357.489C49.7354 321.206 54.2314 286.75 65.5381 263.084C77.2471 237.914 92.7273 222.388 108.493 202.125C124.895 182.443 141.549 158.029 169.982 128.408Z"
          stroke="url(#paint17_linear_2361_4244)"
          strokeWidth="3.03407"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.14"
          d="M162.139 120.344C190.678 89.1693 231.728 60.7539 270.676 49.4767C309.811 37.1829 346.83 42.0239 371.708 53.9484C398.279 66.3206 413.985 82.4781 435.261 98.5866C455.879 115.378 482.081 132.124 514.548 161.448C546.266 189.501 575.171 229.854 586.648 268.134C599.155 306.604 594.226 342.989 582.095 367.442C569.508 393.56 553.07 408.998 536.682 429.912C519.599 450.178 502.566 475.933 472.73 507.846C442.238 540.589 399.546 570.24 358.356 580.373C316.754 591.686 280.58 584.259 255.615 570.531C232.037 557.727 217.016 542.642 196.448 527.121C176.495 511.072 150.972 494.587 120.321 466.744C88.6024 438.692 59.6972 398.339 48.2209 360.055C35.7171 321.588 40.6421 285.2 52.7735 260.75C65.3672 234.633 81.8017 219.194 98.1897 198.277C115.273 178.004 132.309 152.256 162.139 120.344Z"
          stroke="url(#paint18_linear_2361_4244)"
          strokeWidth="3.17601"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.1"
          d="M154.261 112.492C184.047 79.0361 227.575 48.2051 268.744 36.0028C310.123 22.6467 349.138 27.9225 374.734 40.6903C402.229 53.9516 417.746 71.0571 439.641 87.7605C460.811 105.209 488.37 122.252 523.234 152.949C557.267 182.224 588.636 225.009 601.05 265.477C614.625 306.15 609.258 344.502 596.268 369.662C582.777 396.688 565.375 411.937 548.381 433.458C530.62 454.271 513.278 481.349 482.055 515.622C465.959 532.884 446.897 550.13 426.123 563.902C405.399 577.768 382.962 588.163 361.383 593.932C317.363 606.209 279.399 598.116 253.773 583.439C229.497 569.746 214.629 553.844 193.419 537.778C172.874 521.107 145.991 504.302 113.082 475.168C79.0485 445.893 47.6792 403.108 35.2651 362.641C21.6972 321.974 27.0645 283.615 40.0538 258.455C53.5454 231.429 70.9476 216.18 87.9409 194.659C105.696 173.847 123.038 146.768 154.261 112.492Z"
          stroke="url(#paint19_linear_2361_4244)"
          strokeWidth="3.30022"
          strokeMiterlimit="10"
        />
        <path
          opacity="0.05"
          d="M146.329 104.853C178.007 69.1253 222.725 35.6303 266.738 22.5193C311.074 8.17265 350.77 13.7524 377.716 27.4584C405.464 41.3179 421.925 60.0153 443.741 77.003C454.645 85.8287 466.982 94.821 481.801 105.477C496.506 116.153 513.692 128.48 531.683 144.405C568.041 175.533 602.1 219.495 615.456 262.757C630.061 306.336 624.375 345.355 610.434 371.842C596.334 399.114 577.312 415.294 560.03 436.74C551.051 447.459 541.899 459.586 531.058 474.151C520.197 488.606 507.66 505.495 491.458 523.183C474.671 541.645 454.645 560.211 432.753 575.055C410.915 590.006 387.194 601.234 364.378 607.517C341.525 613.891 319.544 615.316 300.585 612.78C281.52 610.318 265.474 603.895 252.033 596.312C227.108 581.703 212.476 564.977 190.668 548.388C169.587 531.149 141.331 514.043 106.1 483.637C69.7528 452.499 35.6898 408.544 22.338 365.279C7.72576 321.709 13.4124 282.69 27.3528 256.203C41.4529 228.932 60.4747 212.748 77.7572 191.305C86.7361 180.587 95.8878 168.46 106.726 153.894C117.577 139.44 130.127 122.547 146.329 104.853Z"
          stroke="url(#paint20_linear_2361_4244)"
          strokeWidth="3.42442"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2361_4244"
          x1="305.095"
          y1="296.131"
          x2="305.095"
          y2="333.395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2361_4244"
          x1="305.818"
          y1="282.055"
          x2="305.818"
          y2="347.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2361_4244"
          x1="305.815"
          y1="267.949"
          x2="305.815"
          y2="361.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2361_4244"
          x1="306.545"
          y1="253.844"
          x2="306.545"
          y2="375.469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2361_4244"
          x1="307.262"
          y1="239.747"
          x2="307.262"
          y2="389.512"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2361_4244"
          x1="308.002"
          y1="225.621"
          x2="308.002"
          y2="403.517"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2361_4244"
          x1="308.726"
          y1="211.549"
          x2="308.726"
          y2="417.551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2361_4244"
          x1="309.446"
          y1="197.444"
          x2="309.446"
          y2="431.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2361_4244"
          x1="310.156"
          y1="183.337"
          x2="310.156"
          y2="445.619"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2361_4244"
          x1="310.901"
          y1="169.237"
          x2="310.901"
          y2="459.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2361_4244"
          x1="311.643"
          y1="155.139"
          x2="311.643"
          y2="473.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2361_4244"
          x1="312.354"
          y1="141.029"
          x2="312.354"
          y2="487.705"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2361_4244"
          x1="313.086"
          y1="126.926"
          x2="313.086"
          y2="501.734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2361_4244"
          x1="313.811"
          y1="112.821"
          x2="313.811"
          y2="515.768"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2361_4244"
          x1="314.534"
          y1="98.718"
          x2="314.534"
          y2="529.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2361_4244"
          x1="315.259"
          y1="84.6108"
          x2="315.259"
          y2="543.827"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_2361_4244"
          x1="315.989"
          y1="70.5114"
          x2="315.989"
          y2="557.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_2361_4244"
          x1="316.719"
          y1="56.4053"
          x2="316.719"
          y2="571.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_2361_4244"
          x1="317.435"
          y1="42.3034"
          x2="317.435"
          y2="585.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_2361_4244"
          x1="318.16"
          y1="28.2029"
          x2="318.16"
          y2="599.932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_2361_4244"
          x1="318.894"
          y1="14.1085"
          x2="318.894"
          y2="613.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB1E1E" />
          <stop offset="0.0001" stopColor="#5273EE" />
          <stop offset="0.25" stopColor="#27C7C7" />
          <stop offset="0.515625" stopColor="#D44BE0" />
          <stop offset="0.776042" stopColor="#1991FF" />
          <stop offset="1" stopColor="#EF3F3F" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function FiveStars(props: { rate: number }) {
  return (
    <div className="stars" data-stars="1">
      <svg height="25" width="23" className="star rating" data-rating="1">
        <polygon
          points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"
          fill="d8d8d8"
        />
      </svg>
      <svg height="25" width="23" className="star rating" data-rating="2">
        <polygon
          points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"
          fill="d8d8d8"
        />
      </svg>
      <svg height="25" width="23" className="star rating" data-rating="3">
        <polygon
          points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"
          fill="d8d8d8"
        />
      </svg>
      <svg height="25" width="23" className="star rating" data-rating="4">
        <polygon
          points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"
          fill="d8d8d8"
        />
      </svg>
      <svg height="25" width="23" className="star rating" data-rating="5">
        <polygon
          points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"
          fill="d8d8d8"
        />
      </svg>
    </div>
  )
}

export function PinkSpiralLines() {
  return (
    <svg
      width="1512"
      height="1000"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#a)">
        <path fill="#fff" d="M0 0h1512v1000H0z" />
        <path fill="#fff" d="M0 0h1512v1000H0z" />
        <g opacity=".1">
          <mask
            id="R"
            maskUnits="userSpaceOnUse"
            x="-270"
            y="-235"
            width="1903"
            height="1084"
          >
            <path
              d="M-268.705 45.855s180.9861 677.076 796.253 795.182C985.146 928.878 1106.38 64.9583 1632 655.147"
              stroke="url(#b)"
              strokeWidth="2.3326"
              strokeMiterlimit="10"
            />
            <path
              d="M-235.912 39.022S-75.5498 712.758 533.52 825.523c450.342 83.376 572.88-761.0467 1094.31-190.362"
              stroke="url(#c)"
              strokeWidth="2.28283"
              strokeMiterlimit="10"
            />
            <path
              d="M-203.112 32.188s139.6741 670.4 742.613 777.819c443.04 78.931 566.919-746.0143 1084.169-194.833"
              stroke="url(#d)"
              strokeWidth="2.23302"
              strokeMiterlimit="10"
            />
            <path
              d="M-170.319 25.3548S-51.3984 692.422 545.473 794.492C981.166 868.999 1106.44 63.5097 1619.5 595.187"
              stroke="url(#e)"
              strokeWidth="2.18325"
              strokeMiterlimit="10"
            />
            <path
              d="M-137.516 18.5212S-39.4186 682.261 551.456 778.976C979.752 849.081 1106.47 63.0267 1615.34 575.201"
              stroke="url(#f)"
              strokeWidth="2.13348"
              strokeMiterlimit="10"
            />
            <path
              d="M-104.722 11.687S-27.52 672.106 557.43 763.461c420.847 65.726 549.05-700.9174 1053.74-208.248"
              stroke="url(#g)"
              strokeWidth="2.08368"
              strokeMiterlimit="10"
            />
            <path
              d="M-71.929 4.85453S-15.7003 661.96 563.402 747.947C976.747 809.321 1106.5 62.062 1607.01 535.228"
              stroke="url(#h)"
              strokeWidth="2.03391"
              strokeMiterlimit="10"
            />
            <path
              d="M-39.13-1.97946S-3.95403 651.823 569.382 732.431c405.787 57.051 537.138-670.8529 1033.458-217.19"
              stroke="url(#i)"
              strokeWidth="1.98414"
              strokeMiterlimit="10"
            />
            <path
              d="M-6.33231-8.81221S7.70679 641.699 575.359 716.916c398.17 52.76 531.181-655.8197 1023.321-221.661"
              stroke="url(#j)"
              strokeWidth="1.93434"
              strokeMiterlimit="10"
            />
            <path
              d="M26.4667-15.6463S19.2805 631.589 581.338 701.4C971.83 749.902 1106.57 60.6125 1594.52 475.268"
              stroke="url(#k)"
              strokeWidth="1.88456"
              strokeMiterlimit="10"
            />
            <path
              d="M59.261-22.4805S30.7573 621.496 587.312 685.884C970.063 730.166 1106.58 60.1292 1590.35 455.28"
              stroke="url(#l)"
              strokeWidth="1.83479"
              strokeMiterlimit="10"
            />
            <path
              d="M92.0597-29.3139S42.1426 611.424 593.291 670.369C968.234 710.47 1106.61 59.6466 1586.19 435.294"
              stroke="url(#m)"
              strokeWidth="1.78502"
              strokeMiterlimit="10"
            />
            <path
              d="M124.849-36.1471S53.418 601.376 599.26 654.854c367.068 35.964 507.36-595.6903 982.76-239.547"
              stroke="url(#n)"
              strokeWidth="1.73522"
              strokeMiterlimit="10"
            />
            <path
              d="M157.652-42.9813S64.6031 591.355 605.242 639.338C964.364 671.211 1106.64 58.6799 1577.86 395.32"
              stroke="url(#o)"
              strokeWidth="1.68545"
              strokeMiterlimit="10"
            />
            <path
              d="M190.443-49.8131S75.6658 581.369 611.213 623.825c351.102 27.833 495.447-565.6261 962.477-248.49"
              stroke="url(#p)"
              strokeWidth="1.63568"
              strokeMiterlimit="10"
            />
            <path
              d="M223.247-56.6477S86.6287 571.418 617.197 608.309c343.007 23.849 489.493-550.5938 952.333-252.961"
              stroke="url(#q)"
              strokeWidth="1.58587"
              strokeMiterlimit="10"
            />
            <path
              d="M256.036-63.4812S97.4607 561.511 623.166 592.793C958.003 612.718 1106.7 57.2325 1565.36 335.361"
              stroke="url(#r)"
              strokeWidth="1.5361"
              strokeMiterlimit="10"
            />
            <path
              d="M288.833-70.3147S108.179 551.654 629.143 577.278C955.73 593.342 1106.72 56.7493 1561.2 315.374"
              stroke="url(#s)"
              strokeWidth="1.48633"
              strokeMiterlimit="10"
            />
            <path
              d="M321.632-77.1487S118.775 541.854 635.121 561.763c318.258 12.27 471.619-505.4968 921.909-266.376"
              stroke="url(#t)"
              strokeWidth="1.43653"
              strokeMiterlimit="10"
            />
            <path
              d="M354.429-83.981s-225.186 616.102 286.67 630.229c309.849 8.553 465.661-490.4637 911.771-270.846"
              stroke="url(#u)"
              strokeWidth="1.38676"
              strokeMiterlimit="10"
            />
            <path
              d="M387.23-90.8151S139.585 522.461 647.079 530.733c301.36 4.911 459.711-475.432 901.631-275.318"
              stroke="url(#v)"
              strokeWidth="1.33699"
              strokeMiterlimit="10"
            />
            <path
              d="M420.021-97.6491S149.787 512.887 653.05 515.217c292.79 1.355 453.75-460.3999 891.49-279.79"
              stroke="url(#w)"
              strokeWidth="1.28719"
              strokeMiterlimit="10"
            />
            <path
              d="M452.817-104.482S159.863 503.411 659.025 499.702c284.142-2.111 447.795-445.3665 881.355-284.26"
              stroke="url(#x)"
              strokeWidth="1.23741"
              strokeMiterlimit="10"
            />
            <path
              d="M485.614-111.316S169.81 494.046 665.002 484.187c275.418-5.483 441.838-430.3349 871.208-288.732"
              stroke="url(#y)"
              strokeWidth="1.18764"
              strokeMiterlimit="10"
            />
            <path
              d="M518.408-118.15s-338.78 602.955 152.568 586.821c266.622-8.755 435.884-415.3023 861.074-293.204"
              stroke="url(#z)"
              strokeWidth="1.13784"
              strokeMiterlimit="10"
            />
            <path
              d="M551.211-124.984S189.336 475.709 676.959 453.155C934.717 441.233 1106.89 52.8854 1527.89 155.48"
              stroke="url(#A)"
              strokeWidth="1.08807"
              strokeMiterlimit="10"
            />
            <path
              d="M584.002-131.816S198.918 466.776 682.93 437.642c248.833-14.978 423.97-385.2382 840.79-302.147"
              stroke="url(#B)"
              strokeWidth="1.0383"
              strokeMiterlimit="10"
            />
            <path
              d="M616.799-138.65s-408.393 596.673 72.108 560.776c239.854-17.92 418.013-370.2057 830.643-306.618"
              stroke="url(#C)"
              strokeWidth=".988496"
              strokeMiterlimit="10"
            />
            <path
              d="M649.595-145.483s-431.786 594.962 45.287 552.094C925.714 385.869 1106.94 51.4384 1515.39 95.5221"
              stroke="url(#D)"
              strokeWidth=".938725"
              strokeMiterlimit="10"
            />
            <path
              d="M682.393-152.317s-455.238 593.483 18.468 543.412C922.64 367.653 1106.96 50.9547 1511.23 75.5348"
              stroke="url(#E)"
              strokeWidth=".888953"
              strokeMiterlimit="10"
            />
            <path
              d="M715.192-159.15s-478.724 592.264-8.353 534.73C919.551 349.562 1106.98 50.4723 1507.06 55.5484"
              stroke="url(#F)"
              strokeWidth=".839152"
              strokeMiterlimit="10"
            />
            <path
              d="M747.987-165.983s-502.204 591.337-35.173 526.048C916.462 331.596 1107 49.9892 1502.9 35.5618"
              stroke="url(#G)"
              strokeWidth=".78938"
              strokeMiterlimit="10"
            />
            <path
              d="M780.783-172.817S255.154 417.917 718.79 344.55c194.608-30.796 388.23-295.0436 779.94-328.9751"
              stroke="url(#H)"
              strokeWidth=".739608"
              strokeMiterlimit="10"
            />
            <path
              d="M813.579-179.652s-548.941 590.49-88.814 508.685C910.384 296.032 1107.04 49.022 1494.57-4.41302"
              stroke="url(#I)"
              strokeWidth=".689837"
              strokeMiterlimit="10"
            />
            <path
              d="M846.372-186.484S274.31 404.155 730.739 313.52C907.448 278.429 1107.06 48.5413 1490.4-24.3979"
              stroke="url(#J)"
              strokeWidth=".640036"
              strokeMiterlimit="10"
            />
            <path
              d="M879.173-193.318S284.269 397.896 736.719 298.004C904.633 260.932 1107.08 48.0577 1486.24-44.385"
              stroke="url(#K)"
              strokeWidth=".590264"
              strokeMiterlimit="10"
            />
            <path
              d="M911.969-200.151S294.617 392.093 742.695 282.488C901.965 243.529 1107.1 47.5748 1482.08-64.3719"
              stroke="url(#L)"
              strokeWidth=".540492"
              strokeMiterlimit="10"
            />
            <path
              d="M944.764-206.985S305.488 386.768 748.67 266.974c150.822-40.768 358.45-219.8819 729.24-351.3321"
              stroke="url(#M)"
              strokeWidth=".490691"
              strokeMiterlimit="10"
            />
            <path
              d="M977.563-213.82S317.038 381.925 754.649 251.456c142.618-42.52 352.491-204.8488 719.101-355.803"
              stroke="url(#N)"
              strokeWidth=".440919"
              strokeMiterlimit="10"
            />
            <path
              d="M1010.36-220.653S329.432 377.561 760.624 235.942C895.331 191.7 1107.16 46.1251 1469.58-124.332"
              stroke="url(#O)"
              strokeWidth=".391147"
              strokeMiterlimit="10"
            />
            <path
              d="M1043.16-227.486S342.852 373.635 766.602 220.427c127.14-45.968 340.578-174.7844 698.818-364.746"
              stroke="url(#P)"
              strokeWidth=".341346"
              strokeMiterlimit="10"
            />
            <path
              d="M1075.95-234.32s-1193.789 1004.241 385.3 70.014"
              stroke="url(#Q)"
              strokeWidth=".291575"
              strokeMiterlimit="10"
            />
          </mask>
          <g mask="url(#R)">
            <path
              transform="matrix(-1 0 0 1 1561.29 -268.34)"
              fill="url(#S)"
              d="M0 0h1699.53v1277.69H0z"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="2598.71"
          y1="-1555.08"
          x2="1922.31"
          y2="1456.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="2576.48"
          y1="-1529.63"
          x2="1915.58"
          y2="1420.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="d"
          x1="2554.25"
          y1="-1504.18"
          x2="1908.86"
          y2="1384.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="2532.08"
          y1="-1478.75"
          x2="1902.24"
          y2="1348.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="f"
          x1="2509.33"
          y1="-1457.82"
          x2="1887.51"
          y2="1319.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="g"
          x1="2486.97"
          y1="-1437.85"
          x2="1872.07"
          y2="1290.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="h"
          x1="2465.29"
          y1="-1418.03"
          x2="1857.81"
          y2="1262.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="i"
          x1="2444.38"
          y1="-1398.38"
          x2="1844.88"
          y2="1234.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="j"
          x1="2424.27"
          y1="-1378.91"
          x2="1833.31"
          y2="1206.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="k"
          x1="2404.96"
          y1="-1359.62"
          x2="1823.13"
          y2="1178.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="l"
          x1="2386.44"
          y1="-1340.5"
          x2="1814.31"
          y2="1151.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="m"
          x1="2368.7"
          y1="-1321.56"
          x2="1806.83"
          y2="1125.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="n"
          x1="2351.69"
          y1="-1302.79"
          x2="1800.62"
          y2="1098.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="o"
          x1="2335.4"
          y1="-1284.18"
          x2="1795.65"
          y2="1072.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="p"
          x1="2319.79"
          y1="-1265.73"
          x2="1791.84"
          y2="1046.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="q"
          x1="2304.83"
          y1="-1247.44"
          x2="1789.13"
          y2="1020.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="r"
          x1="2290.48"
          y1="-1229.29"
          x2="1787.46"
          y2="995.139"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="s"
          x1="2276.71"
          y1="-1211.29"
          x2="1786.76"
          y2="969.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="t"
          x1="2263.49"
          y1="-1193.42"
          x2="1786.96"
          y2="944.841"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="u"
          x1="2250.79"
          y1="-1175.69"
          x2="1788.02"
          y2="919.975"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="v"
          x1="2238.58"
          y1="-1158.08"
          x2="1789.86"
          y2="895.268"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="w"
          x1="2226.83"
          y1="-1140.6"
          x2="1792.42"
          y2="870.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="x"
          x1="2215.52"
          y1="-1123.24"
          x2="1795.65"
          y2="846.258"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="y"
          x1="2204.61"
          y1="-1106.01"
          x2="1799.5"
          y2="821.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="z"
          x1="2194.09"
          y1="-1088.89"
          x2="1803.89"
          y2="797.651"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="A"
          x1="2183.94"
          y1="-1071.88"
          x2="1808.79"
          y2="773.451"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="B"
          x1="2174.11"
          y1="-1054.98"
          x2="1814.12"
          y2="749.298"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="C"
          x1="2164.6"
          y1="-1038.19"
          x2="1819.85"
          y2="725.169"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="D"
          x1="2155.38"
          y1="-1021.52"
          x2="1825.9"
          y2="701.052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="E"
          x1="2146.43"
          y1="-1004.95"
          x2="1832.23"
          y2="676.931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="F"
          x1="2137.71"
          y1="-988.482"
          x2="1838.77"
          y2="652.793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="G"
          x1="2129.21"
          y1="-972.125"
          x2="1845.45"
          y2="628.629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="H"
          x1="2120.9"
          y1="-955.876"
          x2="1852.2"
          y2="604.429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="I"
          x1="2112.73"
          y1="-939.738"
          x2="1858.96"
          y2="580.194"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="J"
          x1="2104.69"
          y1="-923.714"
          x2="1865.62"
          y2="555.934"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="K"
          x1="2096.72"
          y1="-907.847"
          x2="1872.06"
          y2="531.714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="L"
          x1="2088.73"
          y1="-892.306"
          x2="1877.87"
          y2="507.836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="M"
          x1="2080.68"
          y1="-877.146"
          x2="1882.9"
          y2="484.426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="N"
          x1="2072.5"
          y1="-862.406"
          x2="1886.99"
          y2="461.583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="O"
          x1="2064.12"
          y1="-848.118"
          x2="1890.01"
          y2="439.421"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="P"
          x1="2055.49"
          y1="-834.313"
          x2="1891.84"
          y2="418.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="Q"
          x1="2046.53"
          y1="-821.01"
          x2="1892.36"
          y2="397.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2388FF" />
          <stop offset="1" stop-color="#384CFF" />
        </linearGradient>
        <linearGradient
          id="S"
          x1="468.37"
          y1="940.655"
          x2="833.565"
          y2="-79.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2B4BC3" />
          <stop offset=".330122" stop-color="#CC6192" />
          <stop offset=".52923" stop-color="#F98D83" />
          <stop offset="1" stop-color="#000315" stop-opacity=".29" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h1512v1000H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function PremagicLogoWithLines() {
  return (
    <svg
      width="593"
      height="219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path fill="url(#a)" d="M77.9922 98h457v121h-457z" />
      <path
        d="M120.117 74.7146 117.373 5"
        stroke="url(#b)"
        strokeWidth="9.45747"
        strokeLinecap="round"
      />
      <path
        d="M48.1784 99.5087 5.58374 43.6423"
        stroke="url(#c)"
        strokeWidth="9.45747"
        strokeLinecap="round"
      />
      <path
        d="m81.1338 83.5737-8.4769-25.8281"
        stroke="url(#d)"
        strokeWidth="9.45747"
        strokeLinecap="round"
      />
      <path
        d="m524.433 94.1604 1.559-39.6152"
        stroke="url(#e)"
        strokeWidth="5.37419"
        strokeLinecap="round"
      />
      <path
        d="m565.312 108.25 24.204-31.7463"
        stroke="url(#f)"
        strokeWidth="5.37419"
        strokeLinecap="round"
      />
      <path
        d="m546.584 99.1946 4.817-14.6768"
        stroke="url(#g)"
        strokeWidth="5.37419"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="b"
          x1="118.855"
          y1="5"
          x2="123.584"
          y2="74.7488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF957D" />
          <stop offset="1" stop-color="#4F40BE" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="-9.46796"
          y1="45.1406"
          x2="-3.88718"
          y2="104.624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF957D" />
          <stop offset="1" stop-color="#4F40BE" />
        </linearGradient>
        <linearGradient
          id="d"
          x1="81.1708"
          y1="57.0157"
          x2="83.4581"
          y2="83.5088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF957D" />
          <stop offset="1" stop-color="#4F40BE" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="525.15"
          y1="54.5452"
          x2="522.463"
          y2="94.1798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF957D" />
          <stop offset="1" stop-color="#4F40BE" />
        </linearGradient>
        <linearGradient
          id="f"
          x1="598.069"
          y1="77.355"
          x2="594.898"
          y2="111.156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF957D" />
          <stop offset="1" stop-color="#4F40BE" />
        </linearGradient>
        <linearGradient
          id="g"
          x1="546.563"
          y1="84.103"
          x2="545.263"
          y2="99.1577"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF957D" />
          <stop offset="1" stop-color="#4F40BE" />
        </linearGradient>
        <pattern
          id="a"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#h"
            transform="matrix(.00131 0 0 .00496 0 -.00622821)"
          />
        </pattern>
        <image
          id="h"
          width="761"
          height="204"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  )
}

export function BlueArrowRight(props: { className?: string }) {
  const { className } = props
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M0 6.08496L11.592 6.08496" stroke="#294CF8" strokeWidth="1.5" />
      <path
        d="M7.13281 0C7.13273 2.33345 7.2602 5.92337 11.5913 5.92337"
        stroke="#294CF8"
        strokeWidth="1.5"
      />
      <path
        d="M7.13281 11.7041C7.13273 9.49094 7.2602 6.08606 11.5913 6.08606"
        stroke="#294CF8"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export function BlackArrowRight(props: { className?: string }) {
  const { className } = props
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M5.68311 12H19.6831M19.6831 12L12.6831 5M19.6831 12L12.6831 19"
        stroke="#121212"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function WhiteArrowRight(props: { className?: string }) {
  const { className } = props
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M4.92505 10.5001H16.5917M16.5917 10.5001L10.7584 4.66675M16.5917 10.5001L10.7584 16.3334"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowBlackDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
    >
      <path
        d="M1 1.05762L4.93957 4.942L8.87914 1.05762"
        stroke="black"
        strokeWidth="1.27032"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowWhiteDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
    >
      <path
        d="M1 1.05762L4.93957 4.942L8.87914 1.05762"
        stroke="white"
        strokeWidth="1.27032"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function OrangeTick() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <circle cx="10.6831" cy="10" r="10" fill="#FFF1EF" />
      <path
        d="M6.51636 10L8.54495 12.0286C8.70996 12.1936 8.79246 12.2761 8.8876 12.307C8.97129 12.3342 9.06143 12.3342 9.14511 12.307C9.24025 12.2761 9.32275 12.1936 9.48776 12.0286L14.0164 7.5"
        stroke="#E15D4B"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

type IconWithColorProps = {
  color: string
}
export function QuoteIconWithColor(props: IconWithColorProps) {
  const { color } = props
  return (
    <svg
      width="35"
      height="26"
      viewBox="0 0 35 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8979 22.7648C13.7053 24.0658 12.3771 24.8248 10.9135 25.0416C9.44979 25.2042 8.01323 24.9603 6.60378 24.3098C5.24853 23.6051 4.08302 22.6022 3.10725 21.3011C2.13147 19.8917 1.50806 18.2654 1.23701 16.4223C0.965959 14.5249 1.26411 12.4921 2.13147 10.3237C3.05304 8.10106 4.67933 6.06819 7.01035 4.22506C9.39558 2.32771 12.2416 1.02668 15.5484 0.32195C16.1447 0.213532 16.5513 0.186427 16.7681 0.240637C16.985 0.294846 17.1205 0.376161 17.1747 0.484582C17.1747 0.972471 17.0121 1.32483 16.6868 1.54167C15.3316 2.30061 14.1931 3.24928 13.2716 4.38769C12.35 5.52609 11.7808 6.63739 11.564 7.72159C11.3471 8.75157 11.5911 9.51051 12.2958 9.9984C12.5126 10.161 13.0276 10.6218 13.8408 11.3808C14.6539 12.0855 15.4129 13.0341 16.1176 14.2268C16.8223 15.3652 17.1476 16.6662 17.0934 18.1299C17.0934 19.5935 16.3615 21.1385 14.8979 22.7648ZM31.974 22.7648C30.7813 24.0658 29.4532 24.8248 27.9895 25.0416C26.5259 25.2042 25.0893 24.9603 23.6799 24.3098C22.3246 23.6051 21.1591 22.6022 20.1833 21.3011C19.2076 19.8917 18.5841 18.2654 18.3131 16.4223C18.042 14.5249 18.3402 12.4921 19.2076 10.3237C20.1291 8.10106 21.7554 6.06819 24.0864 4.22506C26.4717 2.32771 29.3177 1.02668 32.6245 0.32195C33.2208 0.213532 33.6274 0.186427 33.8442 0.240637C34.061 0.294846 34.1966 0.376161 34.2508 0.484582C34.2508 0.972471 34.0881 1.32483 33.7629 1.54167C32.4076 2.30061 31.2692 3.24928 30.3477 4.38769C29.4261 5.52609 28.8569 6.63739 28.6401 7.72159C28.4232 8.75157 28.6672 9.51051 29.3719 9.9984C29.5887 10.161 30.1037 10.6218 30.9169 11.3808C31.73 12.0855 32.489 13.0341 33.1937 14.2268C33.8984 15.3652 34.2237 16.6662 34.1695 18.1299C34.1695 19.5935 33.4376 21.1385 31.974 22.7648Z"
        fill={color}
      />
    </svg>
  )
}

export function File(props: { className?: string }) {
  const { className } = props
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M14.6831 2.26946V6.4C14.6831 6.96005 14.6831 7.24008 14.7921 7.45399C14.888 7.64215 15.041 7.79513 15.2291 7.89101C15.443 8 15.7231 8 16.2831 8H20.4136M20.6831 9.98822V17.2C20.6831 18.8802 20.6831 19.7202 20.3561 20.362C20.0685 20.9265 19.6096 21.3854 19.0451 21.673C18.4033 22 17.5633 22 15.8831 22H9.48311C7.80295 22 6.96287 22 6.32113 21.673C5.75665 21.3854 5.29771 20.9265 5.01009 20.362C4.68311 19.7202 4.68311 18.8802 4.68311 17.2V6.8C4.68311 5.11984 4.68311 4.27976 5.01009 3.63803C5.29771 3.07354 5.75665 2.6146 6.32113 2.32698C6.96287 2 7.80295 2 9.48311 2H12.6949C13.4287 2 13.7955 2 14.1408 2.08289C14.4469 2.15638 14.7395 2.27759 15.008 2.44208C15.3107 2.6276 15.5701 2.88703 16.089 3.40589L19.2772 6.59411C19.7961 7.11297 20.0555 7.3724 20.241 7.67515C20.4055 7.94356 20.5267 8.2362 20.6002 8.5423C20.6831 8.88757 20.6831 9.25445 20.6831 9.98822Z"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SmilingFace(props: IconWithColorProps) {
  const { color } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M8.68311 14C8.68311 14 10.1831 16 12.6831 16C15.1831 16 16.6831 14 16.6831 14M15.6831 9H15.6931M8.68311 9H10.6831M22.6831 12C22.6831 17.5228 18.206 22 12.6831 22C7.16026 22 2.68311 17.5228 2.68311 12C2.68311 6.47715 7.16026 2 12.6831 2C18.206 2 22.6831 6.47715 22.6831 12ZM16.1831 9C16.1831 9.27614 15.9592 9.5 15.6831 9.5C15.407 9.5 15.1831 9.27614 15.1831 9C15.1831 8.72386 15.407 8.5 15.6831 8.5C15.9592 8.5 16.1831 8.72386 16.1831 9Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MultiStars(props: IconWithColorProps) {
  const { color } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M5.18311 22V17M5.18311 7V2M2.68311 4.5H7.68311M2.68311 19.5H7.68311M13.6831 3L11.9489 7.50886C11.6669 8.24209 11.5259 8.60871 11.3066 8.91709C11.1123 9.1904 10.8735 9.42919 10.6002 9.62353C10.2918 9.84281 9.9252 9.98381 9.19197 10.2658L4.68311 12L9.19197 13.7342C9.9252 14.0162 10.2918 14.1572 10.6002 14.3765C10.8735 14.5708 11.1123 14.8096 11.3066 15.0829C11.5259 15.3913 11.6669 15.7579 11.9489 16.4911L13.6831 21L15.4173 16.4911C15.6993 15.7579 15.8403 15.3913 16.0596 15.0829C16.2539 14.8096 16.4927 14.5708 16.766 14.3765C17.0744 14.1572 17.441 14.0162 18.1742 13.7342L22.6831 12L18.1742 10.2658C17.441 9.98381 17.0744 9.8428 16.766 9.62353C16.4927 9.42919 16.2539 9.1904 16.0596 8.91709C15.8403 8.60871 15.6993 8.24209 15.4173 7.50886L13.6831 3Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Rocket(props: IconWithColorProps) {
  const { color } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M12.1831 15L9.18311 12M12.1831 15C13.58 14.4687 14.92 13.7987 16.1831 13M12.1831 15V20C12.1831 20 15.2131 19.45 16.1831 18C17.2631 16.38 16.1831 13 16.1831 13M9.18311 12C9.71525 10.6194 10.3853 9.29607 11.1831 8.05C12.3483 6.18699 13.9707 4.65305 15.8961 3.5941C17.8215 2.53514 19.9858 1.98637 22.1831 2C22.1831 4.72 21.4031 9.5 16.1831 13M9.18311 12H4.18311C4.18311 12 4.73311 8.97 6.18311 8C7.80311 6.92 11.1831 8 11.1831 8M4.68311 16.5C3.18311 17.76 2.68311 21.5 2.68311 21.5C2.68311 21.5 6.42311 21 7.68311 19.5C8.39311 18.66 8.38311 17.37 7.59311 16.59C7.20441 16.219 6.6924 16.0046 6.15533 15.988C5.61826 15.9714 5.09398 16.1537 4.68311 16.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SpeedoMeter(props: IconWithColorProps) {
  const { color } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M5.68311 12C5.68311 8.13401 8.81711 5 12.6831 5M17.183 7.5L12.683 12M22.6831 12C22.6831 17.5228 18.206 22 12.6831 22C7.16026 22 2.68311 17.5228 2.68311 12C2.68311 6.47715 7.16026 2 12.6831 2C18.206 2 22.6831 6.47715 22.6831 12ZM13.6831 12C13.6831 12.5523 13.2354 13 12.6831 13C12.1308 13 11.6831 12.5523 11.6831 12C11.6831 11.4477 12.1308 11 12.6831 11C13.2354 11 13.6831 11.4477 13.6831 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Box(props: IconWithColorProps) {
  const { color } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M4.18311 8H16.6831M16.6831 8V20.5M16.6831 8L21.1831 3.5M21.6831 15.3373V3.8C21.6831 3.51997 21.6831 3.37996 21.6286 3.273C21.5807 3.17892 21.5042 3.10243 21.4101 3.0545C21.3031 3 21.1631 3 20.8831 3H9.34585C9.10126 3 8.97896 3 8.86387 3.02763C8.76184 3.05213 8.66429 3.09253 8.57482 3.14736C8.4739 3.2092 8.38743 3.29568 8.21448 3.46863L4.15173 7.53137C3.97878 7.70432 3.89231 7.7908 3.83047 7.89172C3.77564 7.98119 3.73523 8.07873 3.71074 8.18077C3.68311 8.29586 3.68311 8.41815 3.68311 8.66274V20.2C3.68311 20.48 3.68311 20.62 3.7376 20.727C3.78554 20.8211 3.86203 20.8976 3.95611 20.9455C4.06307 21 4.20308 21 4.48311 21H16.0204C16.265 21 16.3872 21 16.5023 20.9724C16.6044 20.9479 16.7019 20.9075 16.7914 20.8526C16.8923 20.7908 16.9788 20.7043 17.1517 20.5314L21.2145 16.4686C21.3874 16.2957 21.4739 16.2092 21.5357 16.1083C21.5906 16.0188 21.631 15.9213 21.6555 15.8192C21.6831 15.7041 21.6831 15.5818 21.6831 15.3373Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
